import { KinShipEnum } from "./types";

export function validateCPF(cpf: string): boolean {
  let sum, rest;
  sum = 0;
  if (cpf == "00000000000") return false;

  for (let i = 1; i <= 9; i++)
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(cpf.substring(9, 10))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(cpf.substring(10, 11))) return false;
  return true;
}

export function validatePhoneNumber(phone: string): boolean {
  const phoneRegex = new RegExp(
    /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
  );

  return phoneRegex.test(phone) && phone.length >= 12;
}

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const countries = [
  {
    name: "Afghanistan",
    cca2: "af",
    dialCode: "93",
  },
  {
    name: "Aland Islands",
    cca2: "ax",
    dialCode: "358",
  },
  {
    name: "Albania",
    cca2: "al",
    dialCode: "355",
  },
  {
    name: "Algeria",
    cca2: "dz",
    dialCode: "213",
  },
  {
    name: "American Samoa",
    cca2: "as",
    dialCode: "1",
    prefixes: ["684"],
  },
  {
    name: "Andorra",
    cca2: "ad",
    dialCode: "376",
  },
  {
    name: "Angola",
    cca2: "ao",
    dialCode: "244",
  },
  {
    name: "Anguilla",
    cca2: "ai",
    dialCode: "1",
    prefixes: ["264"],
  },
  {
    name: "Antigua and Barbuda",
    cca2: "ag",
    dialCode: "1",
    prefixes: ["268"],
  },
  {
    name: "Argentina",
    cca2: "ar",
    dialCode: "54",
  },
  {
    name: "Armenia",
    cca2: "am",
    dialCode: "374",
  },
  {
    name: "Aruba",
    cca2: "aw",
    dialCode: "297",
  },
  {
    name: "Ascension Island",
    cca2: "ac",
    dialCode: "247",
  },
  {
    name: "Australia",
    cca2: "au",
    dialCode: "61",
  },
  {
    name: "Austria",
    cca2: "at",
    dialCode: "43",
  },
  {
    name: "Azerbaijan",
    cca2: "az",
    dialCode: "994",
  },
  {
    name: "Bahamas",
    cca2: "bs",
    dialCode: "1",
    prefixes: ["242"],
  },
  {
    name: "Bahrain",
    cca2: "bh",
    dialCode: "973",
  },
  {
    name: "Bangladesh",
    cca2: "bd",
    dialCode: "880",
  },
  {
    name: "Barbados",
    cca2: "bb",
    dialCode: "1",
    prefixes: ["246"],
  },
  {
    name: "Belarus",
    cca2: "by",
    dialCode: "375",
  },
  {
    name: "Belgium",
    cca2: "be",
    dialCode: "32",
  },
  {
    name: "Belize",
    cca2: "bz",
    dialCode: "501",
  },
  {
    name: "Benin",
    cca2: "bj",
    dialCode: "229",
  },
  {
    name: "Bermuda",
    cca2: "bm",
    dialCode: "1",
    prefixes: ["441"],
  },
  {
    name: "Bhutan",
    cca2: "bt",
    dialCode: "975",
  },
  {
    name: "Bolivia",
    cca2: "bo",
    dialCode: "591",
  },
  {
    name: "Bosnia and Herzegovina",
    cca2: "ba",
    dialCode: "387",
  },
  {
    name: "Botswana",
    cca2: "bw",
    dialCode: "267",
  },
  {
    name: "Brazil",
    cca2: "br",
    dialCode: "55",
  },
  {
    name: "British Indian Ocean Territory",
    cca2: "io",
    dialCode: "246",
  },
  {
    name: "Brunei Darussalam",
    cca2: "bn",
    dialCode: "673",
  },
  {
    name: "Bulgaria",
    cca2: "bg",
    dialCode: "359",
  },
  {
    name: "Burkina Faso",
    cca2: "bf",
    dialCode: "226",
  },
  {
    name: "Burundi",
    cca2: "bi",
    dialCode: "257",
  },
  {
    name: "Cambodia",
    cca2: "kh",
    dialCode: "855",
  },
  {
    name: "Cameroon",
    cca2: "cm",
    dialCode: "237",
  },
  {
    name: "Canada",
    cca2: "ca",
    dialCode: "1",
  },
  {
    name: "Cape Verde",
    cca2: "cv",
    dialCode: "238",
  },
  {
    name: "Caribbean Netherlands",
    cca2: "bq",
    dialCode: "599",
  },
  {
    name: "Cayman Islands",
    cca2: "ky",
    dialCode: "1",
    prefixes: ["345"],
  },
  {
    name: "Central African Republic",
    cca2: "cf",
    dialCode: "236",
  },
  {
    name: "Chad",
    cca2: "td",
    dialCode: "235",
  },
  {
    name: "Chile",
    cca2: "cl",
    dialCode: "56",
  },
  {
    name: "China",
    cca2: "cn",
    dialCode: "86",
  },
  {
    name: "Christmas Island",
    cca2: "cx",
    dialCode: "61",
  },
  {
    name: "Cocos (Keeling) Islands",
    cca2: "cc",
    dialCode: "61",
  },
  {
    name: "Colombia",
    cca2: "co",
    dialCode: "57",
  },
  {
    name: "Comoros",
    cca2: "km",
    dialCode: "269",
  },
  {
    name: "Congo (DRC)",
    cca2: "cd",
    dialCode: "243",
  },
  {
    name: "Congo (Republic)",
    cca2: "cg",
    dialCode: "242",
  },
  {
    name: "Cook Islands",
    cca2: "ck",
    dialCode: "682",
  },
  {
    name: "Costa Rica",
    cca2: "cr",
    dialCode: "506",
  },
  {
    name: "Côte d'Ivoire",
    cca2: "ci",
    dialCode: "225",
  },
  {
    name: "Croatia",
    cca2: "hr",
    dialCode: "385",
  },
  {
    name: "Cuba",
    cca2: "cu",
    dialCode: "53",
  },
  {
    name: "Curaçao",
    cca2: "cw",
    dialCode: "599",
  },
  {
    name: "Cyprus",
    cca2: "cy",
    dialCode: "357",
  },
  {
    name: "Czech Republic",
    cca2: "cz",
    dialCode: "420",
  },
  {
    name: "Denmark",
    cca2: "dk",
    dialCode: "45",
  },
  {
    name: "Djibouti",
    cca2: "dj",
    dialCode: "253",
  },
  {
    name: "Dominica",
    cca2: "dm",
    dialCode: "1",
    prefixes: ["767"],
  },
  {
    name: "Dominican Republic",
    cca2: "do",
    dialCode: "1",
    prefixes: ["809", "829", "849"],
  },
  {
    name: "Ecuador",
    cca2: "ec",
    dialCode: "593",
  },
  {
    name: "Egypt",
    cca2: "eg",
    dialCode: "20",
  },
  {
    name: "El Salvador",
    cca2: "sv",
    dialCode: "503",
  },
  {
    name: "Equatorial Guinea",
    cca2: "gq",
    dialCode: "240",
  },
  {
    name: "Eritrea",
    cca2: "er",
    dialCode: "291",
  },
  {
    name: "Estonia",
    cca2: "ee",
    dialCode: "372",
  },
  {
    name: "Ethiopia",
    cca2: "et",
    dialCode: "251",
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    cca2: "fk",
    dialCode: "500",
  },
  {
    name: "Faroe Islands",
    cca2: "fo",
    dialCode: "298",
  },
  {
    name: "Fiji",
    cca2: "fj",
    dialCode: "679",
  },
  {
    name: "Finland",
    cca2: "fi",
    dialCode: "358",
  },
  {
    name: "France",
    cca2: "fr",
    dialCode: "33",
  },
  {
    name: "French Guiana",
    cca2: "gf",
    dialCode: "594",
  },
  {
    name: "French Polynesia",
    cca2: "pf",
    dialCode: "689",
  },
  {
    name: "Gabon",
    cca2: "ga",
    dialCode: "241",
  },
  {
    name: "Gambia",
    cca2: "gm",
    dialCode: "220",
  },
  {
    name: "Georgia",
    cca2: "ge",
    dialCode: "995",
  },
  {
    name: "Germany",
    cca2: "de",
    dialCode: "49",
  },
  {
    name: "Ghana",
    cca2: "gh",
    dialCode: "233",
  },
  {
    name: "Gibraltar",
    cca2: "gi",
    dialCode: "350",
  },
  {
    name: "Greece",
    cca2: "gr",
    dialCode: "30",
  },
  {
    name: "Greenland",
    cca2: "gl",
    dialCode: "299",
  },
  {
    name: "Grenada",
    cca2: "gd",
    dialCode: "1",
    prefixes: ["473"],
  },
  {
    name: "Guadeloupe",
    cca2: "gp",
    dialCode: "590",
  },
  {
    name: "Saint Pierre and Miquelon",
    cca2: "pm",
    dialCode: "508",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    cca2: "sh",
    dialCode: "290",
  },
  {
    name: "Guam",
    cca2: "gu",
    dialCode: "1",
    prefixes: ["671"],
  },
  {
    name: "Guatemala",
    cca2: "gt",
    dialCode: "502",
  },
  {
    name: "Guernsey",
    cca2: "gg",
    dialCode: "44",
  },
  {
    name: "Guinea",
    cca2: "gn",
    dialCode: "224",
  },
  {
    name: "Guinea-Bissau",
    cca2: "gw",
    dialCode: "245",
  },
  {
    name: "Guyana",
    cca2: "gy",
    dialCode: "592",
  },
  {
    name: "Haiti",
    cca2: "ht",
    dialCode: "509",
  },
  {
    name: "Honduras",
    cca2: "hn",
    dialCode: "504",
  },
  {
    name: "Hong Kong",
    cca2: "hk",
    dialCode: "852",
  },
  {
    name: "Hungary",
    cca2: "hu",
    dialCode: "36",
  },
  {
    name: "Iceland",
    cca2: "is",
    dialCode: "354",
  },
  {
    name: "India",
    cca2: "in",
    dialCode: "91",
  },
  {
    name: "Indonesia",
    cca2: "id",
    dialCode: "62",
  },
  {
    name: "Iran",
    cca2: "ir",
    dialCode: "98",
  },
  {
    name: "Iraq",
    cca2: "iq",
    dialCode: "964",
  },
  {
    name: "Ireland",
    cca2: "ie",
    dialCode: "353",
  },
  {
    name: "Isle of Man",
    cca2: "im",
    dialCode: "44",
  },
  {
    name: "Israel",
    cca2: "il",
    dialCode: "972",
  },
  {
    name: "Italy",
    cca2: "it",
    dialCode: "39",
  },
  {
    name: "Jamaica",
    cca2: "jm",
    dialCode: "1",
    prefixes: ["876"],
  },
  {
    name: "Japan",
    cca2: "jp",
    dialCode: "81",
  },
  {
    name: "Jersey",
    cca2: "je",
    dialCode: "44",
  },
  {
    name: "Jordan",
    cca2: "jo",
    dialCode: "962",
  },
  {
    name: "Kazakhstan",
    cca2: "kz",
    dialCode: "7",
  },
  {
    name: "Kenya",
    cca2: "ke",
    dialCode: "254",
  },
  {
    name: "Kiribati",
    cca2: "ki",
    dialCode: "686",
  },
  {
    name: "Kuwait",
    cca2: "kw",
    dialCode: "965",
  },
  {
    name: "Kyrgyzstan",
    cca2: "kg",
    dialCode: "996",
  },
  {
    name: "Laos",
    cca2: "la",
    dialCode: "856",
  },
  {
    name: "Latvia",
    cca2: "lv",
    dialCode: "371",
  },
  {
    name: "Lebanon",
    cca2: "lb",
    dialCode: "961",
  },
  {
    name: "Lesotho",
    cca2: "ls",
    dialCode: "266",
  },
  {
    name: "Liberia",
    cca2: "lr",
    dialCode: "231",
  },
  {
    name: "Libya",
    cca2: "ly",
    dialCode: "218",
  },
  {
    name: "Liechtenstein",
    cca2: "li",
    dialCode: "423",
  },
  {
    name: "Lithuania",
    cca2: "lt",
    dialCode: "370",
  },
  {
    name: "Luxembourg",
    cca2: "lu",
    dialCode: "352",
  },
  {
    name: "Macao",
    cca2: "mo",
    dialCode: "853",
  },
  {
    name: "Macedonia",
    cca2: "mk",
    dialCode: "389",
  },
  {
    name: "Madagascar",
    cca2: "mg",
    dialCode: "261",
  },
  {
    name: "Malawi",
    cca2: "mw",
    dialCode: "265",
  },
  {
    name: "Malaysia",
    cca2: "my",
    dialCode: "60",
  },
  {
    name: "Maldives",
    cca2: "mv",
    dialCode: "960",
  },
  {
    name: "Mali",
    cca2: "ml",
    dialCode: "223",
  },
  {
    name: "Malta",
    cca2: "mt",
    dialCode: "356",
  },
  {
    name: "Marshall Islands",
    cca2: "mh",
    dialCode: "692",
  },
  {
    name: "Martinique",
    cca2: "mq",
    dialCode: "596",
  },
  {
    name: "Mauritania",
    cca2: "mr",
    dialCode: "222",
  },
  {
    name: "Mauritius",
    cca2: "mu",
    dialCode: "230",
  },
  {
    name: "Mayotte",
    cca2: "yt",
    dialCode: "262",
  },
  {
    name: "Mexico",
    cca2: "mx",
    dialCode: "52",
  },
  {
    name: "Micronesia",
    cca2: "fm",
    dialCode: "691",
  },
  {
    name: "Moldova",
    cca2: "md",
    dialCode: "373",
  },
  {
    name: "Monaco",
    cca2: "mc",
    dialCode: "377",
  },
  {
    name: "Mongolia",
    cca2: "mn",
    dialCode: "976",
  },
  {
    name: "Montenegro",
    cca2: "me",
    dialCode: "382",
  },
  {
    name: "Montserrat",
    cca2: "ms",
    dialCode: "1",
    prefixes: ["664"],
  },
  {
    name: "Morocco",
    cca2: "ma",
    dialCode: "212",
  },
  {
    name: "Mozambique",
    cca2: "mz",
    dialCode: "258",
  },
  {
    name: "Myanmar (Burma)",
    cca2: "mm",
    dialCode: "95",
  },
  {
    name: "Namibia",
    cca2: "na",
    dialCode: "264",
  },
  {
    name: "Nauru",
    cca2: "nr",
    dialCode: "674",
  },
  {
    name: "Nepal",
    cca2: "np",
    dialCode: "977",
  },
  {
    name: "Netherlands",
    cca2: "nl",
    dialCode: "31",
  },
  {
    name: "New Caledonia",
    cca2: "nc",
    dialCode: "687",
  },
  {
    name: "New Zealand",
    cca2: "nz",
    dialCode: "64",
  },
  {
    name: "Nicaragua",
    cca2: "ni",
    dialCode: "505",
  },
  {
    name: "Niger",
    cca2: "ne",
    dialCode: "227",
  },
  {
    name: "Nigeria",
    cca2: "ng",
    dialCode: "234",
  },
  {
    name: "Niue",
    cca2: "NU",
    dialCode: "683",
  },
  {
    name: "Norfolk Island",
    cca2: "NF",
    dialCode: "672",
  },
  {
    name: "North Korea",
    cca2: "kp",
    dialCode: "850",
  },
  {
    name: "Norway",
    cca2: "no",
    dialCode: "47",
  },
  {
    name: "Oman",
    cca2: "om",
    dialCode: "968",
  },
  {
    name: "Pakistan",
    cca2: "pk",
    dialCode: "92",
  },
  {
    name: "Palau",
    cca2: "pw",
    dialCode: "680",
  },
  {
    name: "Palestinian Territory",
    cca2: "ps",
    dialCode: "970",
  },
  {
    name: "Panama",
    cca2: "pa",
    dialCode: "507",
  },
  {
    name: "Papua New Guinea",
    cca2: "pg",
    dialCode: "675",
  },
  {
    name: "Paraguay",
    cca2: "py",
    dialCode: "595",
  },
  {
    name: "Peru",
    cca2: "pe",
    dialCode: "51",
  },
  {
    name: "Philippines",
    cca2: "ph",
    dialCode: "63",
  },
  {
    name: "Poland",
    cca2: "pl",
    dialCode: "48",
  },
  {
    name: "Portugal",
    cca2: "pt",
    dialCode: "351",
  },
  {
    name: "Puerto Rico",
    cca2: "pr",
    dialCode: "1",
    prefixes: ["787", "939"],
  },
  {
    name: "Qatar",
    cca2: "qa",
    dialCode: "974",
  },
  {
    name: "Réunion",
    cca2: "re",
    dialCode: "262",
  },
  {
    name: "Saint Barthelemy",
    cca2: "bl",
    dialCode: "590",
  },
  {
    name: "Romania",
    cca2: "ro",
    dialCode: "40",
  },
  {
    name: "Russian Federation",
    cca2: "ru",
    dialCode: "7",
  },
  {
    name: "Rwanda",
    cca2: "rw",
    dialCode: "250",
  },
  {
    name: "Saint Kitts and Nevis",
    cca2: "kn",
    dialCode: "1",
    prefixes: ["869"],
  },
  {
    name: "Saint Lucia",
    cca2: "lc",
    dialCode: "1",
    prefixes: ["758"],
  },
  {
    name: "Saint Martin (Saint-Martin",
    cca2: "mf",
    dialCode: "590",
  },
  {
    name: "Saint Vincent and the Grenadines",
    cca2: "vc",
    dialCode: "1",
    prefixes: ["784"],
  },
  {
    name: "Samoa",
    cca2: "ws",
    dialCode: "685",
  },
  {
    name: "San Marino",
    cca2: "sm",
    dialCode: "378",
  },
  {
    name: "São Tomé and Príncipe",
    cca2: "st",
    dialCode: "239",
  },
  {
    name: "Saudi Arabia",
    cca2: "sa",
    dialCode: "966",
  },
  {
    name: "Senegal",
    cca2: "sn",
    dialCode: "221",
  },
  {
    name: "Serbia",
    cca2: "rs",
    dialCode: "381",
  },
  {
    name: "Seychelles",
    cca2: "sc",
    dialCode: "248",
  },
  {
    name: "Sierra Leone",
    cca2: "sl",
    dialCode: "232",
  },
  {
    name: "Singapore",
    cca2: "sg",
    dialCode: "65",
  },
  {
    name: "Slovakia",
    cca2: "sk",
    dialCode: "421",
  },
  {
    name: "Slovenia",
    cca2: "si",
    dialCode: "386",
  },
  {
    name: "Solomon Islands",
    cca2: "sb",
    dialCode: "677",
  },
  {
    name: "Somalia",
    cca2: "so",
    dialCode: "252",
  },
  {
    name: "South Africa",
    cca2: "za",
    dialCode: "27",
  },
  {
    name: "South Korea",
    cca2: "kr",
    dialCode: "82",
  },
  {
    name: "South Sudan",
    cca2: "ss",
    dialCode: "211",
  },
  {
    name: "Spain",
    cca2: "es",
    dialCode: "34",
  },
  {
    name: "Sri Lanka",
    cca2: "lk",
    dialCode: "94",
  },
  {
    name: "Sudan",
    cca2: "sd",
    dialCode: "249",
  },
  {
    name: "Suriname",
    cca2: "sr",
    dialCode: "597",
  },
  {
    name: "Swaziland",
    cca2: "sz",
    dialCode: "268",
  },
  {
    name: "Sweden",
    cca2: "se",
    dialCode: "46",
  },
  {
    name: "Switzerland",
    cca2: "ch",
    dialCode: "41",
  },
  {
    name: "Syrian Arab Republic",
    cca2: "sy",
    dialCode: "963",
  },
  {
    name: "Taiwan, Province of China",
    cca2: "tw",
    dialCode: "886",
  },
  {
    name: "Tajikistan",
    cca2: "tj",
    dialCode: "992",
  },
  {
    name: "Tanzania",
    cca2: "tz",
    dialCode: "255",
  },
  {
    name: "Thailand",
    cca2: "th",
    dialCode: "66",
  },
  {
    name: "Timor-Leste",
    cca2: "tl",
    dialCode: "670",
  },
  {
    name: "Togo",
    cca2: "tg",
    dialCode: "228",
  },
  {
    name: "Tokelau",
    cca2: "tk",
    dialCode: "690",
  },
  {
    name: "Tonga",
    cca2: "to",
    dialCode: "676",
  },
  {
    name: "Trinidad and Tobago",
    cca2: "tt",
    dialCode: "1",
    prefixes: ["868"],
  },
  {
    name: "Tristan da Cunha",
    cca2: "ta",
    dialCode: "290",
  },
  {
    name: "Tunisia",
    cca2: "tn",
    dialCode: "216",
  },
  {
    name: "Turkey",
    cca2: "tr",
    dialCode: "90",
  },
  {
    name: "Turkmenistan",
    cca2: "tm",
    dialCode: "993",
  },
  {
    name: "Turks and Caicos Islands",
    cca2: "tc",
    dialCode: "1",
    prefixes: ["649"],
  },
  {
    name: "Tuvalu",
    cca2: "tv",
    dialCode: "688",
  },
  {
    name: "Uganda",
    cca2: "ug",
    dialCode: "256",
  },
  {
    name: "Ukraine",
    cca2: "ua",
    dialCode: "380",
  },
  {
    name: "United Arab Emirates",
    cca2: "ae",
    dialCode: "971",
  },
  {
    name: "United Kingdom",
    cca2: "gb",
    dialCode: "44",
  },
  {
    name: "United States",
    cca2: "us",
    dialCode: "1",
  },
  {
    name: "Uruguay",
    cca2: "uy",
    dialCode: "598",
  },
  {
    name: "Uzbekistan",
    cca2: "uz",
    dialCode: "998",
  },
  {
    name: "Vanuatu",
    cca2: "vu",
    dialCode: "678",
  },
  {
    name: "Vatican City",
    cca2: "va",
    dialCode: "379",
  },
  {
    name: "Venezuela",
    cca2: "ve",
    dialCode: "58",
  },
  {
    name: "Viet Nam",
    cca2: "vn",
    dialCode: "84",
  },
  {
    name: "Virgin Islands (British)",
    cca2: "vg",
    dialCode: "1",
    prefixes: ["284"],
  },
  {
    name: "Virgin Islands (U.S.)",
    cca2: "vi",
    dialCode: "1",
    prefixes: ["340"],
  },
  {
    name: "Wallis and Futuna",
    cca2: "wf",
    dialCode: "681",
  },
  {
    name: "Western Sahara",
    cca2: "eh",
    dialCode: "212",
  },
  {
    name: "Yemen",
    cca2: "ye",
    dialCode: "967",
  },
  {
    name: "Zambia",
    cca2: "zm",
    dialCode: "260",
  },
  {
    name: "Zimbabwe",
    cca2: "zw",
    dialCode: "263",
  },
];

export const StatesAndCities = {
  Acre: [
    "Acrelândia",
    "Assis Brasil",
    "Brasiléia",
    "Bujari",
    "Capixaba",
    "Cruzeiro do Sul",
    "Epitaciolândia",
    "Feijó",
    "Jordão",
    "Mâncio Lima",
    "Manoel Urbano",
    "Marechal Thaumaturgo",
    "Plácido de Castro",
    "Porto Acre",
    "Porto Walter",
    "Rio Branco",
    "Rodrigues Alves",
    "Santa Rosa do Purus",
    "Senador Guiomard",
    "Sena Madureira",
    "Tarauacá",
    "Xapuri",
  ],
  Alagoas: [
    "Água Branca",
    "Anadia",
    "Arapiraca",
    "Atalaia",
    "Barra de Santo Antônio",
    "Barra de São Miguel",
    "Batalha",
    "Belém",
    "Belo Monte",
    "Boca da Mata",
    "Branquinha",
    "Cacimbinhas",
    "Cajueiro",
    "Campestre",
    "Campo Alegre",
    "Campo Grande",
    "Canapi",
    "Capela",
    "Carneiros",
    "Chã Preta",
    "Coité do Noia",
    "Colônia Leopoldina",
    "Coqueiro Seco",
    "Coruripe",
    "Craíbas",
    "Delmiro Gouveia",
    "Dois Riachos",
    "Estrela de Alagoas",
    "Feira Grande",
    "Feliz Deserto",
    "Flexeiras",
    "Girau do Ponciano",
    "Ibateguara",
    "Igaci",
    "Igreja Nova",
    "Inhapi",
    "Jacaré dos Homens",
    "Jacuípe",
    "Japaratinga",
    "Jaramataia",
    "Jequiá da Praia",
    "Joaquim Gomes",
    "Jundiá",
    "Junqueiro",
    "Lagoa da Canoa",
    "Limoeiro de Anadia",
    "Maceió",
    "Major Izidoro",
    "Maragogi",
    "Maravilha",
    "Marechal Deodoro",
    "Maribondo",
    "Mar Vermelho",
    "Mata Grande",
    "Matriz de Camaragibe",
    "Messias",
    "Minador do Negrão",
    "Monteirópolis",
    "Murici",
    "Novo Lino",
    "Olho d'Água das Flores",
    "Olho d'Água do Casado",
    "Olho d'Água Grande",
    "Olivença",
    "Ouro Branco",
    "Palestina",
    "Palmeira dos Índios",
    "Pão de Açúcar",
    "Pariconha",
    "Paripueira",
    "Passo de Camaragibe",
    "Paulo Jacinto",
    "Penedo",
    "Piaçabuçu",
    "Pilar",
    "Pindoba",
    "Piranhas",
    "Poço das Trincheiras",
    "Porto Calvo",
    "Porto de Pedras",
    "Porto Real do Colégio",
    "Quebrangulo",
    "Rio Largo",
    "Roteiro",
    "Santa Luzia do Norte",
    "Santana do Ipanema",
    "Santana do Mundaú",
    "São Brás",
    "São José da Laje",
    "São José da Tapera",
    "São Luís do Quitunde",
    "São Miguel dos Campos",
    "São Miguel dos Milagres",
    "São Sebastião",
    "Satuba",
    "Senador Rui Palmeira",
    "Tanque d'Arca",
    "Taquarana",
    "Teotônio Vilela",
    "Traipu",
    "União dos Palmares",
    "Viçosa",
  ],
  Amapá: [
    "Amapá",
    "Calçoene",
    "Cutias",
    "Ferreira Gomes",
    "Itaubal",
    "Laranjal do Jari",
    "Macapá",
    "Mazagão",
    "Oiapoque",
    "Pedra Branca do Amapari",
    "Porto Grande",
    "Pracuúba",
    "Santana",
    "Serra do Navio",
    "Tartarugalzinho",
    "Vitória do Jari",
  ],
  Amazonas: [
    "Alvarães",
    "Amaturá",
    "Anamã",
    "Anori",
    "Apuí",
    "Atalaia do Norte",
    "Autazes",
    "Barcelos",
    "Barreirinha",
    "Benjamin Constant",
    "Beruri",
    "Boa Vista do Ramos",
    "Boca do Acre",
    "Borba",
    "Caapiranga",
    "Canutama",
    "Carauari",
    "Careiro",
    "Careiro da Várzea",
    "Coari",
    "Codajás",
    "Eirunepé",
    "Envira",
    "Fonte Boa",
    "Guajará",
    "Humaitá",
    "Ipixuna",
    "Iranduba",
    "Itacoatiara",
    "Itamarati",
    "Itapiranga",
    "Japurá",
    "Juruá",
    "Jutaí",
    "Lábrea",
    "Manacapuru",
    "Manaquiri",
    "Manaus",
    "Manicoré",
    "Maraã",
    "Maués",
    "Nhamundá",
    "Nova Olinda do Norte",
    "Novo Aripuanã",
    "Novo Airão",
    "Parintins",
    "Pauini",
    "Presidente Figueiredo",
    "Rio Preto da Eva",
    "Santa Isabel do Rio Negro",
    "Santo Antônio do Içá",
    "São Gabriel da Cachoeira",
    "São Paulo de Olivença",
    "São Sebastião do Uatumã",
    "Silves",
    "Tabatinga",
    "Tapauá",
    "Tefé",
    "Tonantins",
    "Uarini",
    "Urucará",
    "Urucurituba",
  ],
  Bahia: [
    "Abaíra",
    "Abaré",
    "Acajutiba",
    "Adustina",
    "Água Fria",
    "Aiquara",
    "Alagoinhas",
    "Alcobaça",
    "Almadina",
    "Amargosa",
    "Amélia Rodrigues",
    "América Dourada",
    "Anagé",
    "Andaraí",
    "Andorinha",
    "Angical",
    "Anguera",
    "Antas",
    "Antônio Cardoso",
    "Antônio Gonçalves",
    "Aporá",
    "Apuarema",
    "Araçás",
    "Aracatu",
    "Araci",
    "Aramari",
    "Arataca",
    "Aratuípe",
    "Aurelino Leal",
    "Baianópolis",
    "Baixa Grande",
    "Banzaê",
    "Barra",
    "Barra da Estiva",
    "Barra do Choça",
    "Barra do Mendes",
    "Barra do Rocha",
    "Barreiras",
    "Barro Alto",
    "Barrocas",
    "Barro Preto",
    "Belmonte",
    "Belo Campo",
    "Biritinga",
    "Boa Nova",
    "Boa Vista do Tupim",
    "Bom Jesus da Lapa",
    "Bom Jesus da Serra",
    "Boninal",
    "Bonito",
    "Boquira",
    "Botuporã",
    "Brejões",
    "Brejolândia",
    "Brotas de Macaúbas",
    "Brumado",
    "Buerarema",
    "Buritirama",
    "Caatiba",
    "Cabaceiras do Paraguaçu",
    "Cachoeira",
    "Caculé",
    "Caém",
    "Caetanos",
    "Caetité",
    "Cafarnaum",
    "Cairu",
    "Caldeirão Grande",
    "Camacan",
    "Camaçari",
    "Camamu",
    "Campo Alegre de Lourdes",
    "Campo Formoso",
    "Canápolis",
    "Canarana",
    "Canavieiras",
    "Candeal",
    "Candeias",
    "Candiba",
    "Cândido Sales",
    "Cansanção",
    "Canudos",
    "Capela do Alto Alegre",
    "Capim Grosso",
    "Caraíbas",
    "Caravelas",
    "Cardeal da Silva",
    "Carinhanha",
    "Casa Nova",
    "Castro Alves",
    "Catolândia",
    "Catu",
    "Caturama",
    "Central",
    "Chorrochó",
    "Cícero Dantas",
    "Cipó",
    "Coaraci",
    "Cocos",
    "Conceição da Feira",
    "Conceição do Almeida",
    "Conceição do Coité",
    "Conceição do Jacuípe",
    "Conde",
    "Condeúba",
    "Contendas do Sincorá",
    "Coração de Maria",
    "Cordeiros",
    "Coribe",
    "Coronel João Sá",
    "Correntina",
    "Cotegipe",
    "Cravolândia",
    "Crisópolis",
    "Cristópolis",
    "Cruz das Almas",
    "Curaçá",
    "Dário Meira",
    "Dias d'Ávila",
    "Dom Basílio",
    "Dom Macedo Costa",
    "Elísio Medrado",
    "Encruzilhada",
    "Entre Rios",
    "Érico Cardoso",
    "Esplanada",
    "Euclides da Cunha",
    "Eunápolis",
    "Fátima",
    "Feira da Mata",
    "Feira de Santana",
    "Filadélfia",
    "Firmino Alves",
    "Floresta Azul",
    "Formosa do Rio Preto",
    "Gandu",
    "Gavião",
    "Gentio do Ouro",
    "Glória",
    "Gongogi",
    "Governador Mangabeira",
    "Guajeru",
    "Guanambi",
    "Guaratinga",
    "Heliópolis",
    "Iaçu",
    "Ibiassucê",
    "Ibicaraí",
    "Ibicoara",
    "Ibicuí",
    "Ibipeba",
    "Ibipitanga",
    "Ibiquera",
    "Ibirapitanga",
    "Ibirapuã",
    "Ibirataia",
    "Ibitiara",
    "Ibititá",
    "Ibotirama",
    "Ichu",
    "Igaporã",
    "Igrapiúna",
    "Iguaí",
    "Ilhéus",
    "Inhambupe",
    "Ipecaetá",
    "Ipiaú",
    "Ipirá",
    "Ipupiara",
    "Irajuba",
    "Iramaia",
    "Iraquara",
    "Irará",
    "Irecê",
    "Itabela",
    "Itaberaba",
    "Itabuna",
    "Itacaré",
    "Itaetê",
    "Itagi",
    "Itagibá",
    "Itagimirim",
    "Itaguaçu da Bahia",
    "Itaju do Colônia",
    "Itajuípe",
    "Itamaraju",
    "Itamari",
    "Itambé",
    "Itanagra",
    "Itanhém",
    "Itaparica",
    "Itapé",
    "Itapebi",
    "Itapetinga",
    "Itapicuru",
    "Itapitanga",
    "Itaquara",
    "Itarantim",
    "Itatim",
    "Itiruçu",
    "Itiúba",
    "Itororó",
    "Ituaçu",
    "Ituberá",
    "Iuiú",
    "Jaborandi",
    "Jacaraci",
    "Jacobina",
    "Jaguaquara",
    "Jaguarari",
    "Jaguaripe",
    "Jandaíra",
    "Jequié",
    "Jeremoabo",
    "Jiquiriçá",
    "Jitaúna",
    "João Dourado",
    "Juazeiro",
    "Jucuruçu",
    "Jussara",
    "Jussari",
    "Jussiape",
    "Lafaiete Coutinho",
    "Lagoa Real",
    "Laje",
    "Lajedão",
    "Lajedinho",
    "Lajedo do Tabocal",
    "Lamarão",
    "Lapão",
    "Lauro de Freitas",
    "Lençóis",
    "Licínio de Almeida",
    "Livramento de Nossa Senhora",
    "Luís Eduardo Magalhães",
    "Macajuba",
    "Macarani",
    "Macaúbas",
    "Macururé",
    "Madre de Deus",
    "Maetinga",
    "Maiquinique",
    "Mairi",
    "Malhada",
    "Malhada de Pedras",
    "Manoel Vitorino",
    "Mansidão",
    "Maracás",
    "Maragogipe",
    "Maraú",
    "Marcionílio Souza",
    "Mascote",
    "Mata de São João",
    "Matina",
    "Medeiros Neto",
    "Miguel Calmon",
    "Milagres",
    "Mirangaba",
    "Mirante",
    "Monte Santo",
    "Morpará",
    "Morro do Chapéu",
    "Mortugaba",
    "Mucugê",
    "Mucuri",
    "Mulungu do Morro",
    "Mundo Novo",
    "Muniz Ferreira",
    "Muquém do São Francisco",
    "Muritiba",
    "Mutuípe",
    "Nazaré",
    "Nilo Peçanha",
    "Nordestina",
    "Nova Canaã",
    "Nova Fátima",
    "Nova Ibiá",
    "Nova Itarana",
    "Nova Redenção",
    "Nova Soure",
    "Nova Viçosa",
    "Novo Horizonte",
    "Novo Triunfo",
    "Olindina",
    "Oliveira dos Brejinhos",
    "Ouriçangas",
    "Ourolândia",
    "Palmas de Monte Alto",
    "Palmeiras",
    "Paramirim",
    "Paratinga",
    "Paripiranga",
    "Pau Brasil",
    "Paulo Afonso",
    "Pé de Serra",
    "Pedrão",
    "Pedro Alexandre",
    "Piatã",
    "Pilão Arcado",
    "Pindaí",
    "Pindobaçu",
    "Pintadas",
    "Piraí do Norte",
    "Piripá",
    "Piritiba",
    "Planaltino",
    "Planalto",
    "Poções",
    "Pojuca",
    "Ponto Novo",
    "Porto Seguro",
    "Potiraguá",
    "Prado",
    "Presidente Dutra",
    "Presidente Jânio Quadros",
    "Presidente Tancredo Neves",
    "Queimadas",
    "Quijingue",
    "Quixabeira",
    "Rafael Jambeiro",
    "Remanso",
    "Retirolândia",
    "Riachão das Neves",
    "Riachão do Jacuípe",
    "Riacho de Santana",
    "Ribeira do Amparo",
    "Ribeira do Pombal",
    "Ribeirão do Largo",
    "Rio de Contas",
    "Rio do Antônio",
    "Rio do Pires",
    "Rio Real",
    "Rodelas",
    "Ruy Barbosa",
    "Salinas da Margarida",
    "Salvador",
    "Santa Bárbara",
    "Santa Brígida",
    "Santa Cruz Cabrália",
    "Santa Cruz da Vitória",
    "Santa Inês",
    "Santaluz",
    "Santa Luzia",
    "Santa Maria da Vitória",
    "Santana",
    "Santanópolis",
    "Santa Rita de Cássia",
    "Santa Teresinha",
    "Santo Amaro",
    "Santo Antônio de Jesus",
    "Santo Estêvão",
    "São Desidério",
    "São Domingos",
    "São Felipe",
    "São Félix",
    "São Félix do Coribe",
    "São Francisco do Conde",
    "São Gabriel",
    "São Gonçalo dos Campos",
    "São José da Vitória",
    "São José do Jacuípe",
    "São Miguel das Matas",
    "São Sebastião do Passé",
    "Sapeaçu",
    "Sátiro Dias",
    "Saubara",
    "Saúde",
    "Seabra",
    "Sebastião Laranjeiras",
    "Senhor do Bonfim",
    "Sento Sé",
    "Serra do Ramalho",
    "Serra Dourada",
    "Serra Preta",
    "Serrinha",
    "Serrolândia",
    "Simões Filho",
    "Sítio do Mato",
    "Sítio do Quinto",
    "Sobradinho",
    "Souto Soares",
    "Tabocas do Brejo Velho",
    "Tanhaçu",
    "Tanque Novo",
    "Tanquinho",
    "Taperoá",
    "Tapiramutá",
    "Teixeira de Freitas",
    "Teodoro Sampaio",
    "Teofilândia",
    "Teolândia",
    "Terra Nova",
    "Tremedal",
    "Tucano",
    "Uauá",
    "Ubaíra",
    "Ubaitaba",
    "Ubatã",
    "Uibaí",
    "Umburanas",
    "Una",
    "Urandi",
    "Uruçuca",
    "Utinga",
    "Valença",
    "Valente",
    "Várzea da Roça",
    "Várzea do Poço",
    "Várzea Nova",
    "Varzedo",
    "Vera Cruz",
    "Vereda",
    "Vitória da Conquista",
    "Wagner",
    "Wanderley",
    "Wenceslau Guimarães",
    "Xique-Xique",
  ],
  Ceará: [
    "Abaiara",
    "Acarape",
    "Acaraú",
    "Acopiara",
    "Aiuaba",
    "Alcântaras",
    "Altaneira",
    "Alto Santo",
    "Amontada",
    "Antonina do Norte",
    "Apuiarés",
    "Aquiraz",
    "Aracati",
    "Aracoiaba",
    "Ararendá",
    "Araripe",
    "Aratuba",
    "Arneiroz",
    "Assaré",
    "Aurora",
    "Baixio",
    "Banabuiú",
    "Barbalha",
    "Barreira",
    "Barro",
    "Barroquinha",
    "Baturité",
    "Beberibe",
    "Bela Cruz",
    "Boa Viagem",
    "Brejo Santo",
    "Camocim",
    "Campos Sales",
    "Canindé",
    "Capistrano",
    "Caridade",
    "Cariré",
    "Caririaçu",
    "Cariús",
    "Carnaubal",
    "Cascavel",
    "Catarina",
    "Catunda",
    "Caucaia",
    "Cedro",
    "Chaval",
    "Choró",
    "Chorozinho",
    "Coreaú",
    "Crateús",
    "Crato",
    "Croatá",
    "Cruz",
    "Deputado Irapuan Pinheiro",
    "Ereré",
    "Eusébio",
    "Farias Brito",
    "Forquilha",
    "Fortaleza",
    "Fortim",
    "Frecheirinha",
    "General Sampaio",
    "Graça",
    "Granja",
    "Granjeiro",
    "Groaíras",
    "Guaiúba",
    "Guaraciaba do Norte",
    "Guaramiranga",
    "Hidrolândia",
    "Horizonte",
    "Ibaretama",
    "Ibiapina",
    "Ibicuitinga",
    "Icapuí",
    "Icó",
    "Iguatu",
    "Independência",
    "Ipaporanga",
    "Ipaumirim",
    "Ipu",
    "Ipueiras",
    "Iracema",
    "Irauçuba",
    "Itaiçaba",
    "Itaitinga",
    "Itapajé",
    "Itapipoca",
    "Itapiúna",
    "Itarema",
    "Itatira",
    "Jaguaretama",
    "Jaguaribara",
    "Jaguaribe",
    "Jaguaruana",
    "Jardim",
    "Jati",
    "Jijoca de Jericoacoara",
    "Juazeiro do Norte",
    "Jucás",
    "Lavras da Mangabeira",
    "Limoeiro do Norte",
    "Madalena",
    "Maracanaú",
    "Maranguape",
    "Marco",
    "Martinópole",
    "Massapê",
    "Mauriti",
    "Meruoca",
    "Milagres",
    "Milhã",
    "Miraíma",
    "Missão Velha",
    "Mombaça",
    "Monsenhor Tabosa",
    "Morada Nova",
    "Moraújo",
    "Morrinhos",
    "Mucambo",
    "Mulungu",
    "Nova Olinda",
    "Nova Russas",
    "Novo Oriente",
    "Ocara",
    "Orós",
    "Pacajus",
    "Pacatuba",
    "Pacoti",
    "Pacujá",
    "Palhano",
    "Palmácia",
    "Paracuru",
    "Paraipaba",
    "Parambu",
    "Paramoti",
    "Pedra Branca",
    "Penaforte",
    "Pentecoste",
    "Pereiro",
    "Pindoretama",
    "Piquet Carneiro",
    "Pires Ferreira",
    "Poranga",
    "Porteiras",
    "Potengi",
    "Potiretama",
    "Quiterianópolis",
    "Quixadá",
    "Quixelô",
    "Quixeramobim",
    "Quixeré",
    "Redenção",
    "Reriutaba",
    "Russas",
    "Saboeiro",
    "Salitre",
    "Santana do Acaraú",
    "Santana do Cariri",
    "Santa Quitéria",
    "São Benedito",
    "São Gonçalo do Amarante",
    "São João do Jaguaribe",
    "São Luís do Curu",
    "Senador Pompeu",
    "Senador Sá",
    "Sobral",
    "Solonópole",
    "Tabuleiro do Norte",
    "Tamboril",
    "Tarrafas",
    "Tauá",
    "Tejuçuoca",
    "Tianguá",
    "Trairi",
    "Tururu",
    "Ubajara",
    "Umari",
    "Umirim",
    "Uruburetama",
    "Uruoca",
    "Varjota",
    "Várzea Alegre",
    "Viçosa do Ceará",
  ],
  "Distrito Federal": [
    "Arniqueira",
    "Brazlândia",
    "Candangolândia",
    "Ceilândia",
    "Cruzeiro",
    "Fercal",
    "Gama",
    "Guará",
    "Itapoã",
    "Jardim Botânico",
    "Lago Norte",
    "Lago Sul",
    "Núcleo Bandeirante",
    "Paranoá",
    "Park Way",
    "Planaltina",
    "Plano Piloto",
    "Recanto das Emas",
    "Riacho Fundo",
    "Riacho Fundo II",
    "SCIA",
    "SIA",
    "Samambaia",
    "Santa Maria",
    "Sobradinho",
    "Sobradinho II",
    "Sol Nascente/Pôr do Sol",
    "Sudoeste/Octogonal",
    "São Sebastião",
    "Taguatinga",
    "Varjão",
    "Vicente Pires",
    "Águas Claras",
  ],
  "Espírito Santo": [
    "Afonso Cláudio",
    "Água Doce do Norte",
    "Águia Branca",
    "Alegre",
    "Alfredo Chaves",
    "Alto Rio Novo",
    "Anchieta",
    "Apiacá",
    "Aracruz",
    "Atílio Vivácqua",
    "Baixo Guandu",
    "Barra de São Francisco",
    "Boa Esperança",
    "Bom Jesus do Norte",
    "Brejetuba",
    "Cachoeiro de Itapemirim",
    "Cariacica",
    "Castelo",
    "Colatina",
    "Conceição da Barra",
    "Conceição do Castelo",
    "Divino de São Lourenço",
    "Domingos Martins",
    "Dores do Rio Preto",
    "Ecoporanga",
    "Fundão",
    "Governador Lindenberg",
    "Guaçuí",
    "Guarapari",
    "Ibatiba",
    "Ibiraçu",
    "Ibitirama",
    "Iconha",
    "Irupi",
    "Itaguaçu",
    "Itapemirim",
    "Itarana",
    "Iúna",
    "Jaguaré",
    "Jerônimo Monteiro",
    "João Neiva",
    "Laranja da Terra",
    "Linhares",
    "Mantenópolis",
    "Marataízes",
    "Marechal Floriano",
    "Marilândia",
    "Mimoso do Sul",
    "Montanha",
    "Mucurici",
    "Muniz Freire",
    "Muqui",
    "Nova Venécia",
    "Pancas",
    "Pedro Canário",
    "Pinheiros",
    "Piúma",
    "Ponto Belo",
    "Presidente Kennedy",
    "Rio Bananal",
    "Rio Novo do Sul",
    "Santa Leopoldina",
    "Santa Maria de Jetibá",
    "Santa Teresa",
    "São Domingos do Norte",
    "São Gabriel da Palha",
    "São José do Calçado",
    "São Mateus",
    "São Roque do Canaã",
    "Serra",
    "Sooretama",
    "Vargem Alta",
    "Venda Nova do Imigrante",
    "Viana",
    "Vila Pavão",
    "Vila Valério",
    "Vila Velha",
    "Vitória",
  ],
  Goiás: [
    "Abadia de Goiás",
    "Abadiânia",
    "Acreúna",
    "Adelândia",
    "Água Fria de Goiás",
    "Água Limpa",
    "Águas Lindas de Goiás",
    "Alexânia",
    "Aloândia",
    "Alto Horizonte",
    "Alto Paraíso de Goiás",
    "Alvorada do Norte",
    "Amaralina",
    "Americano do Brasil",
    "Amorinópolis",
    "Anápolis",
    "Anhanguera",
    "Anicuns",
    "Aparecida de Goiânia",
    "Aparecida do Rio Doce",
    "Aporé",
    "Araçu",
    "Aragarças",
    "Aragoiânia",
    "Araguapaz",
    "Arenópolis",
    "Aruanã",
    "Aurilândia",
    "Avelinópolis",
    "Baliza",
    "Barro Alto",
    "Bela Vista de Goiás",
    "Bom Jardim de Goiás",
    "Bom Jesus de Goiás",
    "Bonfinópolis",
    "Bonópolis",
    "Brazabrantes",
    "Britânia",
    "Buriti Alegre",
    "Buriti de Goiás",
    "Buritinópolis",
    "Cabeceiras",
    "Cachoeira Alta",
    "Cachoeira de Goiás",
    "Cachoeira Dourada",
    "Caçu",
    "Caiapônia",
    "Caldas Novas",
    "Caldazinha",
    "Campestre de Goiás",
    "Campinaçu",
    "Campinorte",
    "Campo Alegre de Goiás",
    "Campo Limpo de Goiás",
    "Campos Belos",
    "Campos Verdes",
    "Carmo do Rio Verde",
    "Castelândia",
    "Catalão",
    "Caturaí",
    "Cavalcante",
    "Ceres",
    "Cezarina",
    "Chapadão do Céu",
    "Cidade Ocidental",
    "Cocalzinho de Goiás",
    "Colinas do Sul",
    "Córrego do Ouro",
    "Corumbá de Goiás",
    "Corumbaíba",
    "Cristalina",
    "Cristianópolis",
    "Crixás",
    "Cromínia",
    "Cumari",
    "Damianópolis",
    "Damolândia",
    "Davinópolis",
    "Diorama",
    "Divinópolis de Goiás",
    "Doverlândia",
    "Edealina",
    "Edéia",
    "Estrela do Norte",
    "Faina",
    "Fazenda Nova",
    "Firminópolis",
    "Flores de Goiás",
    "Formosa",
    "Formoso",
    "Gameleira de Goiás",
    "Goianápolis",
    "Goiandira",
    "Goianésia",
    "Goiânia",
    "Goianira",
    "Goiás",
    "Goiatuba",
    "Gouvelândia",
    "Guapó",
    "Guaraíta",
    "Guarani de Goiás",
    "Guarinos",
    "Heitoraí",
    "Hidrolândia",
    "Hidrolina",
    "Iaciara",
    "Inaciolândia",
    "Indiara",
    "Inhumas",
    "Ipameri",
    "Ipiranga de Goiás",
    "Iporá",
    "Israelândia",
    "Itaberaí",
    "Itaguari",
    "Itaguaru",
    "Itajá",
    "Itapaci",
    "Itapirapuã",
    "Itapuranga",
    "Itarumã",
    "Itauçu",
    "Itumbiara",
    "Ivolândia",
    "Jandaia",
    "Jaraguá",
    "Jataí",
    "Jaupaci",
    "Jesúpolis",
    "Joviânia",
    "Jussara",
    "Lagoa Santa",
    "Leopoldo de Bulhões",
    "Luziânia",
    "Mairipotaba",
    "Mambaí",
    "Mara Rosa",
    "Marzagão",
    "Matrinchã",
    "Maurilândia",
    "Mimoso de Goiás",
    "Minaçu",
    "Mineiros",
    "Moiporá",
    "Monte Alegre de Goiás",
    "Montes Claros de Goiás",
    "Montividiu",
    "Montividiu do Norte",
    "Morrinhos",
    "Morro Agudo de Goiás",
    "Mossâmedes",
    "Mozarlândia",
    "Mundo Novo",
    "Mutunópolis",
    "Nazário",
    "Nerópolis",
    "Niquelândia",
    "Nova América",
    "Nova Aurora",
    "Nova Crixás",
    "Nova Glória",
    "Nova Iguaçu de Goiás",
    "Nova Roma",
    "Nova Veneza",
    "Novo Brasil",
    "Novo Gama",
    "Novo Planalto",
    "Orizona",
    "Ouro Verde de Goiás",
    "Ouvidor",
    "Padre Bernardo",
    "Palestina de Goiás",
    "Palmeiras de Goiás",
    "Palmelo",
    "Palminópolis",
    "Panamá",
    "Paranaiguara",
    "Paraúna",
    "Perolândia",
    "Petrolina de Goiás",
    "Pilar de Goiás",
    "Piracanjuba",
    "Piranhas",
    "Pirenópolis",
    "Pires do Rio",
    "Planaltina",
    "Pontalina",
    "Porangatu",
    "Porteirão",
    "Portelândia",
    "Posse",
    "Professor Jamil",
    "Quirinópolis",
    "Rialma",
    "Rianápolis",
    "Rio Quente",
    "Rio Verde",
    "Rubiataba",
    "Sanclerlândia",
    "Santa Bárbara de Goiás",
    "Santa Cruz de Goiás",
    "Santa Fé de Goiás",
    "Santa Helena de Goiás",
    "Santa Isabel",
    "Santa Rita do Araguaia",
    "Santa Rita do Novo Destino",
    "Santa Rosa de Goiás",
    "Santa Tereza de Goiás",
    "Santa Terezinha de Goiás",
    "Santo Antônio da Barra",
    "Santo Antônio de Goiás",
    "Santo Antônio do Descoberto",
    "São Domingos",
    "São Francisco de Goiás",
    "São João d'Aliança",
    "São João da Paraúna",
    "São Luís de Montes Belos",
    "São Luiz do Norte",
    "São Miguel do Araguaia",
    "São Miguel do Passa-Quatro",
    "São Patrício",
    "São Simão",
    "Senador Canedo",
    "Serranópolis",
    "Silvânia",
    "Simolândia",
    "Sítio d'Abadia",
    "Taquaral de Goiás",
    "Teresina de Goiás",
    "Terezópolis de Goiás",
    "Três Ranchos",
    "Trindade",
    "Trombas",
    "Turvânia",
    "Turvelândia",
    "Uirapuru",
    "Uruaçu",
    "Uruana",
    "Urutaí",
    "Valparaíso de Goiás",
    "Varjão",
    "Vianópolis",
    "Vicentinópolis",
    "Vila Boa",
    "Vila Propício",
  ],
  Maranhão: [
    "Açailândia",
    "Afonso Cunha",
    "Água Doce do Maranhão",
    "Alcântara",
    "Aldeias Altas",
    "Altamira do Maranhão",
    "Alto Alegre do Maranhão",
    "Alto Alegre do Pindaré",
    "Alto Parnaíba",
    "Amapá do Maranhão",
    "Amarante do Maranhão",
    "Anajatuba",
    "Anapurus",
    "Apicum-Açu",
    "Araguanã",
    "Araioses",
    "Arame",
    "Arari",
    "Axixá",
    "Bacabal",
    "Bacabeira",
    "Bacuri",
    "Bacurituba",
    "Balsas",
    "Barão de Grajaú",
    "Barra do Corda",
    "Barreirinhas",
    "Belágua",
    "Bela Vista do Maranhão",
    "Benedito Leite",
    "Bequimão",
    "Bernardo do Mearim",
    "Boa Vista do Gurupi",
    "Bom Jardim",
    "Bom Jesus das Selvas",
    "Bom Lugar",
    "Brejo",
    "Brejo de Areia",
    "Buriti",
    "Buriti Bravo",
    "Buriticupu",
    "Buritirana",
    "Cachoeira Grande",
    "Cajapió",
    "Cajari",
    "Campestre do Maranhão",
    "Cândido Mendes",
    "Cantanhede",
    "Capinzal do Norte",
    "Carolina",
    "Carutapera",
    "Caxias",
    "Cedral",
    "Central do Maranhão",
    "Centro do Guilherme",
    "Centro Novo do Maranhão",
    "Chapadinha",
    "Cidelândia",
    "Codó",
    "Coelho Neto",
    "Colinas",
    "Conceição do Lago Açu",
    "Coroatá",
    "Cururupu",
    "Davinópolis",
    "Dom Pedro",
    "Duque Bacelar",
    "Esperantinópolis",
    "Estreito",
    "Feira Nova do Maranhão",
    "Fernando Falcão",
    "Formosa da Serra Negra",
    "Fortaleza dos Nogueiras",
    "Fortuna",
    "Godofredo Viana",
    "Gonçalves Dias",
    "Governador Archer",
    "Governador Edison Lobão",
    "Governador Eugênio Barros",
    "Governador Luiz Rocha",
    "Governador Newton Bello",
    "Governador Nunes Freire",
    "Graça Aranha",
    "Grajaú",
    "Guimarães",
    "Humberto de Campos",
    "Icatu",
    "Igarapé do Meio",
    "Igarapé Grande",
    "Imperatriz",
    "Itaipava do Grajaú",
    "Itapecuru-Mirim",
    "Itinga do Maranhão",
    "Jatobá",
    "Jenipapo dos Vieiras",
    "João Lisboa",
    "Joselândia",
    "Junco do Maranhão",
    "Lagoa do Mato",
    "Lagoa Grande do Maranhão",
    "Lago da Pedra",
    "Lago do Junco",
    "Lago dos Rodrigues",
    "Lago Verde",
    "Lajeado Novo",
    "Lima Campos",
    "Loreto",
    "Luís Domingues",
    "Magalhães de Almeida",
    "Maracaçumé",
    "Marajá do Sena",
    "Maranhãozinho",
    "Mata Roma",
    "Matinha",
    "Matões",
    "Matões do Norte",
    "Milagres do Maranhão",
    "Mirador",
    "Miranda do Norte",
    "Mirinzal",
    "Monção",
    "Montes Altos",
    "Morros",
    "Nina Rodrigues",
    "Nova Colinas",
    "Nova Iorque",
    "Nova Olinda do Maranhão",
    "Olho d'Água das Cunhãs",
    "Olinda Nova do Maranhão",
    "Paço do Lumiar",
    "Palmeirândia",
    "Paraibano",
    "Parnarama",
    "Passagem Franca",
    "Pastos Bons",
    "Paulino Neves",
    "Paulo Ramos",
    "Pedreiras",
    "Pedro do Rosário",
    "Penalva",
    "Peri Mirim",
    "Peritoró",
    "Pindaré-Mirim",
    "Pinheiro",
    "Pio XII",
    "Pirapemas",
    "Poção de Pedras",
    "Porto Franco",
    "Porto Rico do Maranhão",
    "Presidente Dutra",
    "Presidente Juscelino",
    "Presidente Médici",
    "Presidente Sarney",
    "Presidente Vargas",
    "Primeira Cruz",
    "Raposa",
    "Riachão",
    "Ribamar Fiquene",
    "Rosário",
    "Sambaíba",
    "Santa Filomena do Maranhão",
    "Santa Helena",
    "Santa Inês",
    "Santa Luzia",
    "Santa Luzia do Paruá",
    "Santana do Maranhão",
    "Santa Quitéria do Maranhão",
    "Santa Rita",
    "Santo Amaro do Maranhão",
    "Santo Antônio dos Lopes",
    "São Benedito do Rio Preto",
    "São Bento",
    "São Bernardo",
    "São Domingos do Azeitão",
    "São Domingos do Maranhão",
    "São Félix de Balsas",
    "São Francisco do Brejão",
    "São Francisco do Maranhão",
    "São João Batista",
    "São João do Caru",
    "São João do Paraíso",
    "São João do Soter",
    "São João dos Patos",
    "São José de Ribamar",
    "São José dos Basílios",
    "São Luís",
    "São Luís Gonzaga do Maranhão",
    "São Mateus do Maranhão",
    "São Pedro da Água Branca",
    "São Pedro dos Crentes",
    "São Raimundo das Mangabeiras",
    "São Raimundo do Doca Bezerra",
    "São Roberto",
    "São Vicente Ferrer",
    "Satubinha",
    "Senador Alexandre Costa",
    "Senador La Rocque",
    "Serrano do Maranhão",
    "Sítio Novo",
    "Sucupira do Norte",
    "Sucupira do Riachão",
    "Tasso Fragoso",
    "Timbiras",
    "Timon",
    "Trizidela do Vale",
    "Tufilândia",
    "Tuntum",
    "Turiaçu",
    "Turilândia",
    "Tutóia",
    "Urbano Santos",
    "Vargem Grande",
    "Viana",
    "Vila Nova dos Martírios",
    "Vitória do Mearim",
    "Vitorino Freire",
    "Zé Doca",
  ],
  "Mato Grosso": [
    "Acorizal",
    "Água Boa",
    "Alta Floresta",
    "Alto Araguaia",
    "Alto da Boa Vista",
    "Alto Garças",
    "Alto Paraguai",
    "Alto Taquari",
    "Apiacás",
    "Araguaiana",
    "Araguainha",
    "Araputanga",
    "Arenápolis",
    "Aripuanã",
    "Barão de Melgaço",
    "Barra do Bugres",
    "Barra do Garças",
    "Boa Esperança do Norte",
    "Bom Jesus do Araguaia",
    "Brasnorte",
    "Cáceres",
    "Campinápolis",
    "Campo Novo do Parecis",
    "Campos de Júlio",
    "Campo Verde",
    "Canabrava do Norte",
    "Canarana",
    "Carlinda",
    "Castanheira",
    "Chapada dos Guimarães",
    "Cláudia",
    "Cocalinho",
    "Colíder",
    "Colniza",
    "Comodoro",
    "Confresa",
    "Conquista d'Oeste",
    "Cotriguaçu",
    "Cuiabá",
    "Curvelândia",
    "Denise",
    "Diamantino",
    "Dom Aquino",
    "Feliz Natal",
    "Figueirópolis d'Oeste",
    "Gaúcha do Norte",
    "General Carneiro",
    "Glória d'Oeste",
    "Guarantã do Norte",
    "Guiratinga",
    "Indiavaí",
    "Ipiranga do Norte",
    "Itanhangá",
    "Itaúba",
    "Itiquira",
    "Jaciara",
    "Jangada",
    "Jauru",
    "Juara",
    "Juína",
    "Juruena",
    "Juscimeira",
    "Lambari d'Oeste",
    "Lucas do Rio Verde",
    "Luciara",
    "Marcelândia",
    "Matupá",
    "Mirassol d'Oeste",
    "Nobres",
    "Nortelândia",
    "Nossa Senhora do Livramento",
    "Nova Bandeirantes",
    "Nova Brasilândia",
    "Nova Canaã do Norte",
    "Nova Guarita",
    "Nova Lacerda",
    "Nova Marilândia",
    "Nova Maringá",
    "Nova Monte Verde",
    "Nova Mutum",
    "Nova Nazaré",
    "Nova Olímpia",
    "Nova Santa Helena",
    "Nova Ubiratã",
    "Nova Xavantina",
    "Novo Horizonte do Norte",
    "Novo Mundo",
    "Novo Santo Antônio",
    "Novo São Joaquim",
    "Paranaíta",
    "Paranatinga",
    "Pedra Preta",
    "Peixoto de Azevedo",
    "Planalto da Serra",
    "Poconé",
    "Pontal do Araguaia",
    "Ponte Branca",
    "Pontes e Lacerda",
    "Porto Alegre do Norte",
    "Porto dos Gaúchos",
    "Porto Esperidião",
    "Porto Estrela",
    "Poxoréu",
    "Primavera do Leste",
    "Querência",
    "Reserva do Cabaçal",
    "Ribeirão Cascalheira",
    "Ribeirãozinho",
    "Rio Branco",
    "Rondolândia",
    "Rondonópolis",
    "Rosário Oeste",
    "Salto do Céu",
    "Santa Carmem",
    "Santa Cruz do Xingu",
    "Santa Rita do Trivelato",
    "Santa Terezinha",
    "Santo Afonso",
    "Santo Antônio do Leste",
    "Santo Antônio de Leverger",
    "São Félix do Araguaia",
    "São José do Povo",
    "São José do Rio Claro",
    "São José dos Quatro Marcos",
    "São José do Xingu",
    "São Pedro da Cipa",
    "Sapezal",
    "Serra Nova Dourada",
    "Sinop",
    "Sorriso",
    "Tabaporã",
    "Tangará da Serra",
    "Tapurah",
    "Terra Nova do Norte",
    "Tesouro",
    "Torixoréu",
    "União do Sul",
    "Vale de São Domingos",
    "Várzea Grande",
    "Vera",
    "Vila Bela da Santíssima Trindade",
    "Vila Rica",
  ],
  "Mato Grosso do Sul": [
    "Água Clara",
    "Alcinópolis",
    "Amambai",
    "Anastácio",
    "Anaurilândia",
    "Angélica",
    "Antônio João",
    "Aparecida do Taboado",
    "Aquidauana",
    "Aral Moreira",
    "Bandeirantes",
    "Bataguassu",
    "Batayporã",
    "Bela Vista",
    "Bodoquena",
    "Bonito",
    "Brasilândia",
    "Caarapó",
    "Camapuã",
    "Campo Grande",
    "Caracol",
    "Cassilândia",
    "Chapadão do Sul",
    "Corguinho",
    "Coronel Sapucaia",
    "Corumbá",
    "Costa Rica",
    "Deodápolis",
    "Dois Irmãos do Buriti",
    "Douradina",
    "Dourados",
    "Eldorado",
    "Fátima do Sul",
    "Figueirão",
    "Glória de Dourados",
    "Guia Lopes da Laguna",
    "Iguatemi",
    "Itaporã",
    "Itaquiraí",
    "Ivinhema",
    "Japorã",
    "Jaraguari",
    "Jardim",
    "Jateí",
    "Juti",
    "Ladário",
    "Laguna Carapã",
    "Maracaju",
    "Miranda",
    "Mundo Novo",
    "Naviraí",
    "Nioaque",
    "Nova Alvorada do Sul",
    "Nova Andradina",
    "Novo Horizonte do Sul",
    "Paraíso das Águas",
    "Paranaíba",
    "Paranhos",
    "Pedro Gomes",
    "Ponta Porã",
    "Porto Murtinho",
    "Ribas do Rio Pardo",
    "Rio Brilhante",
    "Rio Negro",
    "Rio Verde de Mato Grosso",
    "Rochedo",
    "Santa Rita do Pardo",
    "São Gabriel do Oeste",
    "Selvíria",
    "Sete Quedas",
    "Sidrolândia",
    "Sonora",
    "Tacuru",
    "Taquarussu",
    "Terenos",
    "Três Lagoas",
    "Vicentina",
  ],
  "Minas Gerais": [
    "Abadia dos Dourados",
    "Abaeté",
    "Abre Campo",
    "Acaiaca",
    "Açucena",
    "Água Boa",
    "Água Comprida",
    "Aguanil",
    "Águas Formosas",
    "Águas Vermelhas",
    "Aimorés",
    "Aiuruoca",
    "Alagoa",
    "Albertina",
    "Além Paraíba",
    "Alfenas",
    "Alfredo Vasconcelos",
    "Almenara",
    "Alpercata",
    "Alpinópolis",
    "Alterosa",
    "Alto Caparaó",
    "Alto Jequitibá",
    "Alto Rio Doce",
    "Alvarenga",
    "Alvinópolis",
    "Alvorada de Minas",
    "Amparo do Serra",
    "Andradas",
    "Andrelândia",
    "Angelândia",
    "Antônio Carlos",
    "Antônio Dias",
    "Antônio Prado de Minas",
    "Araçaí",
    "Aracitaba",
    "Araçuaí",
    "Araguari",
    "Arantina",
    "Araponga",
    "Araporã",
    "Arapuá",
    "Araújos",
    "Araxá",
    "Arceburgo",
    "Arcos",
    "Areado",
    "Argirita",
    "Aricanduva",
    "Arinos",
    "Astolfo Dutra",
    "Ataléia",
    "Augusto de Lima",
    "Baependi",
    "Baldim",
    "Bambuí",
    "Bandeira",
    "Bandeira do Sul",
    "Barão de Cocais",
    "Barão de Monte Alto",
    "Barbacena",
    "Barra Longa",
    "Barroso",
    "Bela Vista de Minas",
    "Belmiro Braga",
    "Belo Horizonte",
    "Belo Oriente",
    "Belo Vale",
    "Berilo",
    "Berizal",
    "Bertópolis",
    "Betim",
    "Bias Fortes",
    "Bicas",
    "Biquinhas",
    "Boa Esperança",
    "Bocaina de Minas",
    "Bocaiuva",
    "Bom Despacho",
    "Bom Jardim de Minas",
    "Bom Jesus da Penha",
    "Bom Jesus do Amparo",
    "Bom Jesus do Galho",
    "Bom Repouso",
    "Bom Sucesso",
    "Bonfim",
    "Bonfinópolis de Minas",
    "Bonito de Minas",
    "Borda da Mata",
    "Botelhos",
    "Botumirim",
    "Brasilândia de Minas",
    "Brasília de Minas",
    "Brasópolis",
    "Brás Pires",
    "Braúnas",
    "Brumadinho",
    "Bueno Brandão",
    "Buenópolis",
    "Bugre",
    "Buritis",
    "Buritizeiro",
    "Cabeceira Grande",
    "Cabo Verde",
    "Cachoeira da Prata",
    "Cachoeira de Minas",
    "Cachoeira de Pajeú",
    "Cachoeira Dourada",
    "Caetanópolis",
    "Caeté",
    "Caiana",
    "Cajuri",
    "Caldas",
    "Camacho",
    "Camanducaia",
    "Cambuí",
    "Cambuquira",
    "Campanário",
    "Campanha",
    "Campestre",
    "Campina Verde",
    "Campo Azul",
    "Campo Belo",
    "Campo do Meio",
    "Campo Florido",
    "Campos Altos",
    "Campos Gerais",
    "Canaã",
    "Canápolis",
    "Cana Verde",
    "Candeias",
    "Cantagalo",
    "Caparaó",
    "Capela Nova",
    "Capelinha",
    "Capetinga",
    "Capim Branco",
    "Capinópolis",
    "Capitão Andrade",
    "Capitão Enéas",
    "Capitólio",
    "Caputira",
    "Caraí",
    "Caranaíba",
    "Carandaí",
    "Carangola",
    "Caratinga",
    "Carbonita",
    "Careaçu",
    "Carlos Chagas",
    "Carmésia",
    "Carmo da Cachoeira",
    "Carmo da Mata",
    "Carmo de Minas",
    "Carmo do Cajuru",
    "Carmo do Paranaíba",
    "Carmo do Rio Claro",
    "Carmópolis de Minas",
    "Carneirinho",
    "Carrancas",
    "Carvalhópolis",
    "Carvalhos",
    "Casa Grande",
    "Cascalho Rico",
    "Cássia",
    "Cataguases",
    "Catas Altas",
    "Catas Altas da Noruega",
    "Catuji",
    "Catuti",
    "Caxambu",
    "Cedro do Abaeté",
    "Central de Minas",
    "Centralina",
    "Chácara",
    "Chalé",
    "Chapada do Norte",
    "Chapada Gaúcha",
    "Chiador",
    "Cipotânea",
    "Claraval",
    "Claro dos Poções",
    "Cláudio",
    "Coimbra",
    "Coluna",
    "Comendador Gomes",
    "Comercinho",
    "Conceição da Aparecida",
    "Conceição da Barra de Minas",
    "Conceição das Alagoas",
    "Conceição das Pedras",
    "Conceição de Ipanema",
    "Conceição do Mato Dentro",
    "Conceição do Pará",
    "Conceição do Rio Verde",
    "Conceição dos Ouros",
    "Cônego Marinho",
    "Confins",
    "Congonhal",
    "Congonhas",
    "Congonhas do Norte",
    "Conquista",
    "Conselheiro Lafaiete",
    "Conselheiro Pena",
    "Consolação",
    "Contagem",
    "Coqueiral",
    "Coração de Jesus",
    "Cordisburgo",
    "Cordislândia",
    "Corinto",
    "Coroaci",
    "Coromandel",
    "Coronel Fabriciano",
    "Coronel Murta",
    "Coronel Pacheco",
    "Coronel Xavier Chaves",
    "Córrego Danta",
    "Córrego do Bom Jesus",
    "Córrego Fundo",
    "Córrego Novo",
    "Couto de Magalhães de Minas",
    "Crisólita",
    "Cristais",
    "Cristália",
    "Cristiano Otoni",
    "Cristina",
    "Crucilândia",
    "Cruzeiro da Fortaleza",
    "Cruzília",
    "Cuparaque",
    "Curral de Dentro",
    "Curvelo",
    "Datas",
    "Delfim Moreira",
    "Delfinópolis",
    "Delta",
    "Descoberto",
    "Desterro de Entre Rios",
    "Desterro do Melo",
    "Diamantina",
    "Diogo de Vasconcelos",
    "Dionísio",
    "Divinésia",
    "Divino",
    "Divino das Laranjeiras",
    "Divinolândia de Minas",
    "Divinópolis",
    "Divisa Alegre",
    "Divisa Nova",
    "Divisópolis",
    "Dom Bosco",
    "Dom Cavati",
    "Dom Joaquim",
    "Dom Silvério",
    "Dom Viçoso",
    "Dona Euzébia",
    "Dores de Campos",
    "Dores de Guanhães",
    "Dores do Indaiá",
    "Dores do Turvo",
    "Doresópolis",
    "Douradoquara",
    "Durandé",
    "Elói Mendes",
    "Engenheiro Caldas",
    "Engenheiro Navarro",
    "Entre Folhas",
    "Entre Rios de Minas",
    "Ervália",
    "Esmeraldas",
    "Espera Feliz",
    "Espinosa",
    "Espírito Santo do Dourado",
    "Estiva",
    "Estrela Dalva",
    "Estrela do Indaiá",
    "Estrela do Sul",
    "Eugenópolis",
    "Ewbank da Câmara",
    "Extrema",
    "Fama",
    "Faria Lemos",
    "Felício dos Santos",
    "Felisburgo",
    "Felixlândia",
    "Fernandes Tourinho",
    "Ferros",
    "Fervedouro",
    "Florestal",
    "Formiga",
    "Formoso",
    "Fortaleza de Minas",
    "Fortuna de Minas",
    "Francisco Badaró",
    "Francisco Dumont",
    "Franciscópolis",
    "Francisco Sá",
    "Frei Gaspar",
    "Frei Inocêncio",
    "Frei Lagonegro",
    "Fronteira",
    "Fronteira dos Vales",
    "Fruta de Leite",
    "Frutal",
    "Funilândia",
    "Galileia",
    "Gameleiras",
    "Glaucilândia",
    "Goiabeira",
    "Goianá",
    "Gonçalves",
    "Gonzaga",
    "Gouveia",
    "Governador Valadares",
    "Grão Mogol",
    "Grupiara",
    "Guanhães",
    "Guapé",
    "Guaraciaba",
    "Guaraciama",
    "Guaranésia",
    "Guarani",
    "Guarará",
    "Guarda-Mor",
    "Guaxupé",
    "Guidoval",
    "Guimarânia",
    "Guiricema",
    "Gurinhatã",
    "Heliodora",
    "Iapu",
    "Ibertioga",
    "Ibiá",
    "Ibiaí",
    "Ibiracatu",
    "Ibiraci",
    "Ibirité",
    "Ibitiúra de Minas",
    "Ibituruna",
    "Icaraí de Minas",
    "Igarapé",
    "Igaratinga",
    "Iguatama",
    "Ijaci",
    "Ilicínea",
    "Imbé de Minas",
    "Inconfidentes",
    "Indaiabira",
    "Indianópolis",
    "Ingaí",
    "Inhapim",
    "Inhaúma",
    "Inimutaba",
    "Ipaba",
    "Ipanema",
    "Ipatinga",
    "Ipiaçu",
    "Ipuiuna",
    "Iraí de Minas",
    "Itabira",
    "Itabirinha",
    "Itabirito",
    "Itacambira",
    "Itacarambi",
    "Itaguara",
    "Itaipé",
    "Itajubá",
    "Itamarandiba",
    "Itamarati de Minas",
    "Itambacuri",
    "Itambé do Mato Dentro",
    "Itamogi",
    "Itamonte",
    "Itanhandu",
    "Itanhomi",
    "Itaobim",
    "Itapagipe",
    "Itapecerica",
    "Itapeva",
    "Itatiaiuçu",
    "Itaú de Minas",
    "Itaúna",
    "Itaverava",
    "Itinga",
    "Itueta",
    "Ituiutaba",
    "Itumirim",
    "Iturama",
    "Itutinga",
    "Jaboticatubas",
    "Jacinto",
    "Jacuí",
    "Jacutinga",
    "Jaguaraçu",
    "Jaíba",
    "Jampruca",
    "Janaúba",
    "Januária",
    "Japaraíba",
    "Japonvar",
    "Jeceaba",
    "Jenipapo de Minas",
    "Jequeri",
    "Jequitaí",
    "Jequitibá",
    "Jequitinhonha",
    "Jesuânia",
    "Joaíma",
    "Joanésia",
    "João Monlevade",
    "João Pinheiro",
    "Joaquim Felício",
    "Jordânia",
    "José Gonçalves de Minas",
    "Josenópolis",
    "José Raydan",
    "Juatuba",
    "Juiz de Fora",
    "Juramento",
    "Juruaia",
    "Juvenília",
    "Ladainha",
    "Lagamar",
    "Lagoa da Prata",
    "Lagoa dos Patos",
    "Lagoa Dourada",
    "Lagoa Formosa",
    "Lagoa Grande",
    "Lagoa Santa",
    "Lajinha",
    "Lambari",
    "Lamim",
    "Laranjal",
    "Lassance",
    "Lavras",
    "Leandro Ferreira",
    "Leme do Prado",
    "Leopoldina",
    "Liberdade",
    "Lima Duarte",
    "Limeira do Oeste",
    "Lontra",
    "Luisburgo",
    "Luislândia",
    "Luminárias",
    "Luz",
    "Machacalis",
    "Machado",
    "Madre de Deus de Minas",
    "Malacacheta",
    "Mamonas",
    "Manga",
    "Manhuaçu",
    "Manhumirim",
    "Mantena",
    "Maravilhas",
    "Mar de Espanha",
    "Maria da Fé",
    "Mariana",
    "Marilac",
    "Mário Campos",
    "Maripá de Minas",
    "Marliéria",
    "Marmelópolis",
    "Martinho Campos",
    "Martins Soares",
    "Mata Verde",
    "Materlândia",
    "Mateus Leme",
    "Mathias Lobato",
    "Matias Barbosa",
    "Matias Cardoso",
    "Matipó",
    "Mato Verde",
    "Matozinhos",
    "Matutina",
    "Medeiros",
    "Medina",
    "Mendes Pimentel",
    "Mercês",
    "Mesquita",
    "Minas Novas",
    "Minduri",
    "Mirabela",
    "Miradouro",
    "Miraí",
    "Miravânia",
    "Moeda",
    "Moema",
    "Monjolos",
    "Monsenhor Paulo",
    "Montalvânia",
    "Monte Alegre de Minas",
    "Monte Azul",
    "Monte Belo",
    "Monte Carmelo",
    "Monte Formoso",
    "Monte Santo de Minas",
    "Montes Claros",
    "Monte Sião",
    "Montezuma",
    "Morada Nova de Minas",
    "Morro da Garça",
    "Morro do Pilar",
    "Munhoz",
    "Muriaé",
    "Mutum",
    "Muzambinho",
    "Nacip Raydan",
    "Nanuque",
    "Naque",
    "Natalândia",
    "Natércia",
    "Nazareno",
    "Nepomuceno",
    "Ninheira",
    "Nova Belém",
    "Nova Era",
    "Nova Lima",
    "Nova Módica",
    "Nova Ponte",
    "Nova Porteirinha",
    "Nova Resende",
    "Nova Serrana",
    "Nova União",
    "Novo Cruzeiro",
    "Novo Oriente de Minas",
    "Novorizonte",
    "Olaria",
    "Olhos-d'Água",
    "Olímpio Noronha",
    "Oliveira",
    "Oliveira Fortes",
    "Onça de Pitangui",
    "Oratórios",
    "Orizânia",
    "Ouro Branco",
    "Ouro Fino",
    "Ouro Preto",
    "Ouro Verde de Minas",
    "Padre Carvalho",
    "Padre Paraíso",
    "Paineiras",
    "Pains",
    "Pai Pedro",
    "Paiva",
    "Palma",
    "Palmópolis",
    "Papagaios",
    "Paracatu",
    "Pará de Minas",
    "Paraguaçu",
    "Paraisópolis",
    "Paraopeba",
    "Passabém",
    "Passa Quatro",
    "Passa Tempo",
    "Passa Vinte",
    "Passos",
    "Patis",
    "Patos de Minas",
    "Patrocínio do Muriaé",
    "Paula Cândido",
    "Paulistas",
    "Pavão",
    "Peçanha",
    "Pedra Azul",
    "Pedra Bonita",
    "Pedra do Anta",
    "Pedra do Indaiá",
    "Pedra Dourada",
    "Pedralva",
    "Pedras de Maria da Cruz",
    "Pedrinópolis",
    "Pedro Leopoldo",
    "Pedro Teixeira",
    "Pequeri",
    "Pequi",
    "Perdigão",
    "Perdizes",
    "Perdões",
    "Periquito",
    "Pescador",
    "Piau",
    "Piedade de Caratinga",
    "Piedade de Ponte Nova",
    "Piedade do Rio Grande",
    "Piedade dos Gerais",
    "Pimenta",
    "Pingo-d'Água",
    "Pintópolis",
    "Piracema",
    "Pirajuba",
    "Piranga",
    "Piranguçu",
    "Piranguinho",
    "Pirapetinga",
    "Pirapora",
    "Piraúba",
    "Pitangui",
    "Piumhi",
    "Planura",
    "Poço Fundo",
    "Poços de Caldas",
    "Pocrane",
    "Pompéu",
    "Ponte Nova",
    "Ponto Chique",
    "Ponto dos Volantes",
    "Porteirinha",
    "Porto Firme",
    "Poté",
    "Pouso Alegre",
    "Pouso Alto",
    "Prados",
    "Prata",
    "Pratápolis",
    "Pratinha",
    "Presidente Bernardes",
    "Presidente Juscelino",
    "Presidente Kubitschek",
    "Presidente Olegário",
    "Prudente de Morais",
    "Quartel Geral",
    "Queluzito",
    "Raposos",
    "Raul Soares",
    "Recreio",
    "Reduto",
    "Resende Costa",
    "Resplendor",
    "Ressaquinha",
    "Riachinho",
    "Riacho dos Machados",
    "Ribeirão das Neves",
    "Ribeirão Vermelho",
    "Rio Acima",
    "Rio Casca",
    "Rio Doce",
    "Rio do Prado",
    "Rio Espera",
    "Rio Manso",
    "Rio Novo",
    "Rio Paranaíba",
    "Rio Pardo de Minas",
    "Rio Piracicaba",
    "Rio Pomba",
    "Rio Preto",
    "Rio Vermelho",
    "Ritápolis",
    "Rochedo de Minas",
    "Rodeiro",
    "Romaria",
    "Rosário da Limeira",
    "Rubelita",
    "Rubim",
    "Sabará",
    "Sabinópolis",
    "Sacramento",
    "Salinas",
    "Salto da Divisa",
    "Santa Bárbara",
    "Santa Bárbara do Leste",
    "Santa Bárbara do Monte Verde",
    "Santa Bárbara do Tugúrio",
    "Santa Cruz de Minas",
    "Santa Cruz de Salinas",
    "Santa Cruz do Escalvado",
    "Santa Efigênia de Minas",
    "Santa Fé de Minas",
    "Santa Helena de Minas",
    "Santa Juliana",
    "Santa Luzia",
    "Santa Margarida",
    "Santa Maria de Itabira",
    "Santa Maria do Salto",
    "Santa Maria do Suaçuí",
    "Santana da Vargem",
    "Santana de Cataguases",
    "Santana de Pirapama",
    "Santana do Deserto",
    "Santana do Garambéu",
    "Santana do Jacaré",
    "Santana do Manhuaçu",
    "Santana do Paraíso",
    "Santana do Riacho",
    "Santana dos Montes",
    "Santa Rita de Caldas",
    "Santa Rita de Jacutinga",
    "Santa Rita de Minas",
    "Santa Rita de Ibitipoca",
    "Santa Rita do Itueto",
    "Santa Rita do Sapucaí",
    "Santa Rosa da Serra",
    "Santa Vitória",
    "Santo Antônio do Amparo",
    "Santo Antônio do Aventureiro",
    "Santo Antônio do Grama",
    "Santo Antônio do Itambé",
    "Santo Antônio do Jacinto",
    "Santo Antônio do Monte",
    "Santo Antônio do Retiro",
    "Santo Antônio do Rio Abaixo",
    "Santo Hipólito",
    "Santos Dumont",
    "São Bento Abade",
    "São Brás do Suaçuí",
    "São Domingos das Dores",
    "São Domingos do Prata",
    "São Félix de Minas",
    "São Francisco",
    "São Francisco de Paula",
    "São Francisco de Sales",
    "São Francisco do Glória",
    "São Geraldo",
    "São Geraldo da Piedade",
    "São Geraldo do Baixio",
    "São Gonçalo do Abaeté",
    "São Gonçalo do Pará",
    "São Gonçalo do Rio Abaixo",
    "São Gonçalo do Rio Preto",
    "São Gonçalo do Sapucaí",
    "São Gotardo",
    "São João Batista do Glória",
    "São João da Lagoa",
    "São João da Mata",
    "São João da Ponte",
    "São João das Missões",
    "São João del-Rei",
    "São João do Manhuaçu",
    "São João do Manteninha",
    "São João do Oriente",
    "São João do Pacuí",
    "São João do Paraíso",
    "São João Evangelista",
    "São João Nepomuceno",
    "São Joaquim de Bicas",
    "São José da Barra",
    "São José da Lapa",
    "São José da Safira",
    "São José da Varginha",
    "São José do Alegre",
    "São José do Divino",
    "São José do Goiabal",
    "São José do Jacuri",
    "São José do Mantimento",
    "São Lourenço",
    "São Miguel do Anta",
    "São Pedro da União",
    "São Pedro dos Ferros",
    "São Pedro do Suaçuí",
    "São Romão",
    "São Roque de Minas",
    "São Sebastião da Bela Vista",
    "São Sebastião da Vargem Alegre",
    "São Sebastião do Anta",
    "São Sebastião do Maranhão",
    "São Sebastião do Oeste",
    "São Sebastião do Paraíso",
    "São Sebastião do Rio Preto",
    "São Sebastião do Rio Verde",
    "São Tomé das Letras",
    "São Tiago",
    "São Tomás de Aquino",
    "São Vicente de Minas",
    "Sapucaí-Mirim",
    "Sardoá",
    "Sarzedo",
    "Sem-Peixe",
    "Senador Amaral",
    "Senador Cortes",
    "Senador Firmino",
    "Senador José Bento",
    "Senador Modestino Gonçalves",
    "Senhora de Oliveira",
    "Senhora do Porto",
    "Senhora dos Remédios",
    "Seritinga",
    "Serra Azul de Minas",
    "Serra da Saudade",
    "Serra dos Aimorés",
    "Serra do Salitre",
    "Serrania",
    "Serranópolis de Minas",
    "Serranos",
    "Serro",
    "Sete Lagoas",
    "Setubinha",
    "Silveirânia",
    "Silvianópolis",
    "Simão Pereira",
    "Simonésia",
    "Sobrália",
    "Soledade de Minas",
    "Tabuleiro",
    "Taiobeiras",
    "Taparuba",
    "Tapira",
    "Tapiraí",
    "Taquaraçu de Minas",
    "Tarumirim",
    "Teixeiras",
    "Teófilo Otoni",
    "Timóteo",
    "Tiradentes",
    "Tiros",
    "Tocantins",
    "Tocos do Moji",
    "Toledo",
    "Tombos",
    "Três Corações",
    "Três Marias",
    "Três Pontas",
    "Tumiritinga",
    "Tupaciguara",
    "Turmalina",
    "Turvolândia",
    "Ubá",
    "Ubaí",
    "Ubaporanga",
    "Uberaba",
    "Uberlândia",
    "Umburatiba",
    "Unaí",
    "União de Minas",
    "Uruana de Minas",
    "Urucânia",
    "Urucuia",
    "Vargem Alegre",
    "Vargem Bonita",
    "Vargem Grande do Rio Pardo",
    "Varginha",
    "Varjão de Minas",
    "Várzea da Palma",
    "Varzelândia",
    "Vazante",
    "Verdelândia",
    "Veredinha",
    "Veríssimo",
    "Vermelho Novo",
    "Vespasiano",
    "Viçosa",
    "Vieiras",
    "Virgem da Lapa",
    "Virgínia",
    "Virginópolis",
    "Virgolândia",
    "Visconde do Rio Branco",
    "Volta Grande",
    "Wenceslau Braz",
  ],
  Pará: [
    "Abaetetuba",
    "Abel Figueiredo",
    "Acará",
    "Afuá",
    "Água Azul do Norte",
    "Alenquer",
    "Almeirim",
    "Altamira",
    "Anajás",
    "Ananindeua",
    "Anapu",
    "Augusto Corrêa",
    "Aurora do Pará",
    "Aveiro",
    "Bagre",
    "Baião",
    "Bannach",
    "Barcarena",
    "Belém",
    "Belterra",
    "Benevides",
    "Bom Jesus do Tocantins",
    "Bonito",
    "Bragança",
    "Brasil Novo",
    "Brejo Grande do Araguaia",
    "Breu Branco",
    "Breves",
    "Bujaru",
    "Cachoeira do Arari",
    "Cachoeira do Piriá",
    "Cametá",
    "Canaã dos Carajás",
    "Capanema",
    "Capitão Poço",
    "Castanhal",
    "Chaves",
    "Colares",
    "Conceição do Araguaia",
    "Concórdia do Pará",
    "Cumaru do Norte",
    "Curionópolis",
    "Curralinho",
    "Curuá",
    "Curuçá",
    "Dom Eliseu",
    "Eldorado do Carajás",
    "Faro",
    "Floresta do Araguaia",
    "Garrafão do Norte",
    "Goianésia do Pará",
    "Gurupá",
    "Igarapé-Açu",
    "Igarapé-Miri",
    "Inhangapi",
    "Ipixuna do Pará",
    "Irituia",
    "Itaituba",
    "Itupiranga",
    "Jacareacanga",
    "Jacundá",
    "Juruti",
    "Limoeiro do Ajuru",
    "Mãe do Rio",
    "Magalhães Barata",
    "Marabá",
    "Maracanã",
    "Marapanim",
    "Marituba",
    "Medicilândia",
    "Melgaço",
    "Mocajuba",
    "Moju",
    "Mojuí dos Campos",
    "Monte Alegre",
    "Muaná",
    "Nova Esperança do Piriá",
    "Nova Ipixuna",
    "Nova Timboteua",
    "Novo Progresso",
    "Novo Repartimento",
    "Óbidos",
    "Oeiras do Pará",
    "Oriximiná",
    "Ourém",
    "Ourilândia do Norte",
    "Pacajá",
    "Palestina do Pará",
    "Paragominas",
    "Parauapebas",
    "Pau-d'Arco",
    "Peixe-Boi",
    "Piçarra",
    "Placas",
    "Ponta de Pedras",
    "Portel",
    "Porto de Moz",
    "Prainha",
    "Primavera",
    "Quatipuru",
    "Redenção",
    "Rio Maria",
    "Rondon do Pará",
    "Rurópolis",
    "Salinópolis",
    "Salvaterra",
    "Santa Bárbara do Pará",
    "Santa Cruz do Arari",
    "Santa Izabel do Pará",
    "Santa Luzia do Pará",
    "Santa Maria das Barreiras",
    "Santa Maria do Pará",
    "Santana do Araguaia",
    "Santarém",
    "Santarém Novo",
    "Santo Antônio do Tauá",
    "São Caetano de Odivelas",
    "São Domingos do Araguaia",
    "São Domingos do Capim",
    "São Félix do Xingu",
    "São Francisco do Pará",
    "São Geraldo do Araguaia",
    "São João da Ponta",
    "São João de Pirabas",
    "São João do Araguaia",
    "São Miguel do Guamá",
    "São Sebastião da Boa Vista",
    "Sapucaia",
    "Senador José Porfírio",
    "Soure",
    "Tailândia",
    "Terra Alta",
    "Terra Santa",
    "Tomé-Açu",
    "Tracuateua",
    "Trairão",
    "Tucumã",
    "Tucuruí",
    "Ulianópolis",
    "Uruará",
    "Vigia",
    "Vitória do Xingu",
    "Viseu",
    "Xinguara",
  ],
  Paraíba: [
    "Água Branca",
    "Aguiar",
    "Alagoa Grande",
    "Alagoa Nova",
    "Alagoinha",
    "Alcantil",
    "Algodão de Jandaíra",
    "Alhandra",
    "Amparo",
    "Aparecida",
    "Araçagi",
    "Arara",
    "Araruna",
    "Areia",
    "Areia de Baraúnas",
    "Areial",
    "Aroeiras",
    "Assunção",
    "Baía da Traição",
    "Bananeiras",
    "Baraúna",
    "Barra de Santana",
    "Barra de Santa Rosa",
    "Barra de São Miguel",
    "Bayeux",
    "Belém",
    "Belém do Brejo do Cruz",
    "Bernardino Batista",
    "Boa Ventura",
    "Boa Vista",
    "Bom Jesus",
    "Bom Sucesso",
    "Bonito de Santa Fé",
    "Boqueirão",
    "Borborema",
    "Brejo do Cruz",
    "Brejo dos Santos",
    "Caaporã",
    "Cabaceiras",
    "Cabedelo",
    "Cachoeira dos Índios",
    "Cacimba de Areia",
    "Cacimba de Dentro",
    "Cacimbas",
    "Caiçara",
    "Cajazeiras",
    "Cajazeirinhas",
    "Caldas Brandão",
    "Camalaú",
    "Campina Grande",
    "Capim",
    "Caraúbas",
    "Carrapateira",
    "Casserengue",
    "Catingueira",
    "Catolé do Rocha",
    "Caturité",
    "Conceição",
    "Condado",
    "Conde",
    "Congo",
    "Coremas",
    "Coxixola",
    "Cruz do Espírito Santo",
    "Cubati",
    "Cuité",
    "Cuité de Mamanguape",
    "Cuitegi",
    "Curral de Cima",
    "Curral Velho",
    "Damião",
    "Desterro",
    "Diamante",
    "Dona Inês",
    "Duas Estradas",
    "Emas",
    "Esperança",
    "Fagundes",
    "Frei Martinho",
    "Gado Bravo",
    "Guarabira",
    "Gurinhém",
    "Gurjão",
    "Ibiara",
    "Igaracy",
    "Imaculada",
    "Ingá",
    "Itabaiana",
    "Itaporanga",
    "Itapororoca",
    "Itatuba",
    "Jacaraú",
    "Jericó",
    "João Pessoa",
    "Joca Claudino",
    "Juarez Távora",
    "Juazeirinho",
    "Junco do Seridó",
    "Juripiranga",
    "Juru",
    "Lagoa",
    "Lagoa de Dentro",
    "Lagoa Seca",
    "Lastro",
    "Livramento",
    "Logradouro",
    "Lucena",
    "Mãe d'Água",
    "Malta",
    "Mamanguape",
    "Manaíra",
    "Marcação",
    "Mari",
    "Marizópolis",
    "Massaranduba",
    "Mataraca",
    "Matinhas",
    "Mato Grosso",
    "Matureia",
    "Mogeiro",
    "Montadas",
    "Monte Horebe",
    "Monteiro",
    "Mulungu",
    "Natuba",
    "Nazarezinho",
    "Nova Floresta",
    "Nova Olinda",
    "Nova Palmeira",
    "Olho d'Água",
    "Olivedos",
    "Ouro Velho",
    "Parari",
    "Passagem",
    "Patos",
    "Paulista",
    "Pedra Branca",
    "Pedra Lavrada",
    "Pedras de Fogo",
    "Pedro Régis",
    "Piancó",
    "Picuí",
    "Pilar",
    "Pilões",
    "Pilõezinhos",
    "Pirpirituba",
    "Pitimbu",
    "Pocinhos",
    "Poço Dantas",
    "Poço de José de Moura",
    "Pombal",
    "Prata",
    "Princesa Isabel",
    "Puxinanã",
    "Queimadas",
    "Quixaba",
    "Remígio",
    "Riachão",
    "Riachão do Bacamarte",
    "Riachão do Poço",
    "Riacho de Santo Antônio",
    "Riacho dos Cavalos",
    "Rio Tinto",
    "Salgadinho",
    "Salgado de São Félix",
    "Santa Cecília",
    "Santa Cruz",
    "Santa Helena",
    "Santa Inês",
    "Santa Luzia",
    "Santana de Mangueira",
    "Santana dos Garrotes",
    "Santa Rita",
    "Santa Terezinha",
    "Santo André",
    "São Bento",
    "São Bento de Pombal",
    "São Domingos",
    "São Domingos do Cariri",
    "São Francisco",
    "São João do Cariri",
    "São João do Rio do Peixe",
    "São João do Tigre",
    "São José da Lagoa Tapada",
    "São José de Caiana",
    "São José de Espinharas",
    "São José de Piranhas",
    "São José de Princesa",
    "São José do Bonfim",
    "São José do Brejo do Cruz",
    "São José do Sabugi",
    "São José dos Cordeiros",
    "São José dos Ramos",
    "São Mamede",
    "São Miguel de Taipu",
    "São Sebastião de Lagoa de Roça",
    "São Sebastião do Umbuzeiro",
    "São Vicente do Seridó",
    "Sapé",
    "Serra Branca",
    "Serra da Raiz",
    "Serra Grande",
    "Serra Redonda",
    "Serraria",
    "Sertãozinho",
    "Sobrado",
    "Solânea",
    "Soledade",
    "Sossêgo",
    "Sousa",
    "Sumé",
    "Tacima",
    "Taperoá",
    "Tavares",
    "Teixeira",
    "Tenório",
    "Triunfo",
    "Uiraúna",
    "Umbuzeiro",
    "Várzea",
    "Vieirópolis",
    "Vista Serrana",
    "Zabelê",
  ],
  Paraná: [
    "Abatiá",
    "Adrianópolis",
    "Agudos do Sul",
    "Almirante Tamandaré",
    "Altamira do Paraná",
    "Altônia",
    "Alto Paraíso",
    "Alto Paraná",
    "Alto Piquiri",
    "Alvorada do Sul",
    "Amaporã",
    "Ampére",
    "Anahy",
    "Andirá",
    "Ângulo",
    "Antonina",
    "Antônio Olinto",
    "Apucarana",
    "Arapongas",
    "Arapoti",
    "Arapuã",
    "Araruna",
    "Araucária",
    "Ariranha do Ivaí",
    "Assaí",
    "Assis Chateaubriand",
    "Astorga",
    "Atalaia",
    "Balsa Nova",
    "Bandeirantes",
    "Barbosa Ferraz",
    "Barracão",
    "Barra do Jacaré",
    "Bela Vista da Caroba",
    "Bela Vista do Paraíso",
    "Bituruna",
    "Boa Esperança",
    "Boa Esperança do Iguaçu",
    "Boa Ventura de São Roque",
    "Boa Vista da Aparecida",
    "Bocaiúva do Sul",
    "Bom Jesus do Sul",
    "Bom Sucesso",
    "Bom Sucesso do Sul",
    "Borrazópolis",
    "Braganey",
    "Brasilândia do Sul",
    "Cafeara",
    "Cafelândia",
    "Cafezal do Sul",
    "Califórnia",
    "Cambará",
    "Cambé",
    "Cambira",
    "Campina da Lagoa",
    "Campina do Simão",
    "Campina Grande do Sul",
    "Campo Bonito",
    "Campo do Tenente",
    "Campo Largo",
    "Campo Magro",
    "Campo Mourão",
    "Cândido de Abreu",
    "Candói",
    "Cantagalo",
    "Capanema",
    "Capitão Leônidas Marques",
    "Carambeí",
    "Carlópolis",
    "Cascavel",
    "Castro",
    "Catanduvas",
    "Centenário do Sul",
    "Cerro Azul",
    "Céu Azul",
    "Chopinzinho",
    "Cianorte",
    "Cidade Gaúcha",
    "Clevelândia",
    "Colombo",
    "Colorado",
    "Congonhinhas",
    "Conselheiro Mairinck",
    "Contenda",
    "Corbélia",
    "Cornélio Procópio",
    "Coronel Domingos Soares",
    "Coronel Vivida",
    "Corumbataí do Sul",
    "Cruzeiro do Iguaçu",
    "Cruzeiro do Oeste",
    "Cruzeiro do Sul",
    "Cruz Machado",
    "Cruzmaltina",
    "Curitiba",
    "Curiúva",
    "Diamante d'Oeste",
    "Diamante do Norte",
    "Diamante do Sul",
    "Dois Vizinhos",
    "Douradina",
    "Doutor Camargo",
    "Doutor Ulysses",
    "Enéas Marques",
    "Engenheiro Beltrão",
    "Entre Rios do Oeste",
    "Esperança Nova",
    "Espigão Alto do Iguaçu",
    "Farol",
    "Faxinal",
    "Fazenda Rio Grande",
    "Fênix",
    "Fernandes Pinheiro",
    "Figueira",
    "Floraí",
    "Flor da Serra do Sul",
    "Floresta",
    "Florestópolis",
    "Flórida",
    "Formosa do Oeste",
    "Foz do Iguaçu",
    "Foz do Jordão",
    "Francisco Alves",
    "Francisco Beltrão",
    "General Carneiro",
    "Godoy Moreira",
    "Goioerê",
    "Goioxim",
    "Grandes Rios",
    "Guaíra",
    "Guairaçá",
    "Guamiranga",
    "Guapirama",
    "Guaporema",
    "Guaraci",
    "Guaraniaçu",
    "Guarapuava",
    "Guaraqueçaba",
    "Guaratuba",
    "Honório Serpa",
    "Ibaiti",
    "Ibema",
    "Ibiporã",
    "Icaraíma",
    "Iguaraçu",
    "Iguatu",
    "Imbaú",
    "Imbituva",
    "Inácio Martins",
    "Inajá",
    "Indianópolis",
    "Ipiranga",
    "Iporã",
    "Iracema do Oeste",
    "Irati",
    "Iretama",
    "Itaguajé",
    "Itaipulândia",
    "Itambaracá",
    "Itambé",
    "Itapejara d'Oeste",
    "Itaperuçu",
    "Itaúna do Sul",
    "Ivaí",
    "Ivaiporã",
    "Ivaté",
    "Ivatuba",
    "Jaboti",
    "Jacarezinho",
    "Jaguapitã",
    "Jaguariaíva",
    "Jandaia do Sul",
    "Janiópolis",
    "Japira",
    "Japurá",
    "Jardim Alegre",
    "Jardim Olinda",
    "Jataizinho",
    "Jesuítas",
    "Joaquim Távora",
    "Jundiaí do Sul",
    "Juranda",
    "Jussara",
    "Kaloré",
    "Lapa",
    "Laranjal",
    "Laranjeiras do Sul",
    "Leópolis",
    "Lidianópolis",
    "Lindoeste",
    "Loanda",
    "Lobato",
    "Londrina",
    "Luisiana",
    "Lunardelli",
    "Lupionópolis",
    "Mallet",
    "Mamborê",
    "Mandaguaçu",
    "Mandaguari",
    "Mandirituba",
    "Manfrinópolis",
    "Mangueirinha",
    "Manoel Ribas",
    "Marechal Cândido Rondon",
    "Maria Helena",
    "Marialva",
    "Marilândia do Sul",
    "Marilena",
    "Mariluz",
    "Maringá",
    "Mariópolis",
    "Maripá",
    "Marmeleiro",
    "Marquinho",
    "Marumbi",
    "Matelândia",
    "Matinhos",
    "Mato Rico",
    "Mauá da Serra",
    "Medianeira",
    "Mercedes",
    "Mirador",
    "Miraselva",
    "Missal",
    "Moreira Sales",
    "Morretes",
    "Munhoz de Mello",
    "Nossa Senhora das Graças",
    "Nova Aliança do Ivaí",
    "Nova América da Colina",
    "Nova Aurora",
    "Nova Cantu",
    "Nova Esperança",
    "Nova Esperança do Sudoeste",
    "Nova Fátima",
    "Nova Laranjeiras",
    "Nova Londrina",
    "Nova Olímpia",
    "Nova Prata do Iguaçu",
    "Nova Santa Bárbara",
    "Nova Santa Rosa",
    "Nova Tebas",
    "Novo Itacolomi",
    "Ortigueira",
    "Ourizona",
    "Ouro Verde do Oeste",
    "Paiçandu",
    "Palmas",
    "Palmeira",
    "Palmital",
    "Palotina",
    "Paraíso do Norte",
    "Paranacity",
    "Paranaguá",
    "Paranapoema",
    "Paranavaí",
    "Pato Bragado",
    "Pato Branco",
    "Paula Freitas",
    "Paulo Frontin",
    "Peabiru",
    "Perobal",
    "Pérola",
    "Pérola d'Oeste",
    "Piên",
    "Pinhais",
    "Pinhalão",
    "Pinhal de São Bento",
    "Pinhão",
    "Piraí do Sul",
    "Piraquara",
    "Pitanga",
    "Pitangueiras",
    "Planaltina do Paraná",
    "Planalto",
    "Ponta Grossa",
    "Pontal do Paraná",
    "Porecatu",
    "Porto Amazonas",
    "Porto Barreiro",
    "Porto Rico",
    "Porto Vitória",
    "Prado Ferreira",
    "Pranchita",
    "Presidente Castelo Branco",
    "Primeiro de Maio",
    "Prudentópolis",
    "Quarto Centenário",
    "Quatiguá",
    "Quatro Barras",
    "Quatro Pontes",
    "Quedas do Iguaçu",
    "Querência do Norte",
    "Quinta do Sol",
    "Quitandinha",
    "Ramilândia",
    "Rancho Alegre d'Oeste",
    "Rancho Alegre",
    "Realeza",
    "Rebouças",
    "Renascença",
    "Reserva do Iguaçu",
    "Reserva",
    "Ribeirão Claro",
    "Ribeirão do Pinhal",
    "Rio Azul",
    "Rio Bom",
    "Rio Bonito do Iguaçu",
    "Rio Branco do Ivaí",
    "Rio Branco do Sul",
    "Rio Negro",
    "Rolândia",
    "Roncador",
    "Rondon",
    "Rosário do Ivaí",
    "Sabáudia",
    "Salgado Filho",
    "Salto do Itararé",
    "Salto do Lontra",
    "Santa Amélia",
    "Santa Cecília do Pavão",
    "Santa Cruz de Monte Castelo",
    "Santa Fé",
    "Santa Helena",
    "Santa Inês",
    "Santa Isabel do Ivaí",
    "Santa Izabel do Oeste",
    "Santa Lúcia",
    "Santa Maria do Oeste",
    "Santa Mariana",
    "Santa Mônica",
    "Santana do Itararé",
    "Santa Tereza do Oeste",
    "Santa Terezinha de Itaipu",
    "Santo Antônio da Platina",
    "Santo Antônio do Caiuá",
    "Santo Antônio do Paraíso",
    "Santo Antônio do Sudoeste",
    "Santo Inácio",
    "São Carlos do Ivaí",
    "São Jerônimo da Serra",
    "São João",
    "São João do Caiuá",
    "São João do Ivaí",
    "São João do Triunfo",
    "São Jorge d'Oeste",
    "São Jorge do Ivaí",
    "São Jorge do Patrocínio",
    "São José da Boa Vista",
    "São José das Palmeiras",
    "São José dos Pinhais",
    "São Manoel do Paraná",
    "São Mateus do Sul",
    "São Miguel do Iguaçu",
    "São Pedro do Iguaçu",
    "São Pedro do Ivaí",
    "São Pedro do Paraná",
    "São Sebastião da Amoreira",
    "São Tomé",
    "Sapopema",
    "Sarandi",
    "Saudade do Iguaçu",
    "Sengés",
    "Serranópolis do Iguaçu",
    "Sertaneja",
    "Sertanópolis",
    "Siqueira Campos",
    "Sulina",
    "Tamarana",
    "Tamboara",
    "Tapejara",
    "Tapira",
    "Teixeira Soares",
    "Telêmaco Borba",
    "Terra Boa",
    "Terra Rica",
    "Terra Roxa",
    "Tibagi",
    "Tijucas do Sul",
    "Toledo",
    "Tomazina",
    "Três Barras do Paraná",
    "Tunas do Paraná",
    "Tuneiras do Oeste",
    "Tupãssi",
    "Turvo",
    "Ubiratã",
    "Umuarama",
    "União da Vitória",
    "Uniflor",
    "Uraí",
    "Ventania",
    "Vera Cruz do Oeste",
    "Verê",
    "Virmond",
    "Vitorino",
    "Wenceslau Braz",
    "Xambrê",
  ],
  Pernambuco: [
    "Abreu e Lima",
    "Afogados da Ingazeira",
    "Afrânio",
    "Agrestina",
    "Água Preta",
    "Águas Belas",
    "Alagoinha",
    "Aliança",
    "Altinho",
    "Amaraji",
    "Angelim",
    "Araçoiaba",
    "Araripina",
    "Arcoverde",
    "Barra de Guabiraba",
    "Barreiros",
    "Belém de Maria",
    "Belém do São Francisco",
    "Belo Jardim",
    "Betânia",
    "Bezerros",
    "Bodocó",
    "Bom Conselho",
    "Bom Jardim",
    "Bonito",
    "Brejão",
    "Brejinho",
    "Brejo da Madre de Deus",
    "Buenos Aires",
    "Buíque",
    "Cabo de Santo Agostinho",
    "Cabrobó",
    "Cachoeirinha",
    "Caetés",
    "Calçado",
    "Calumbi",
    "Camaragibe",
    "Camocim de São Félix",
    "Camutanga",
    "Canhotinho",
    "Capoeiras",
    "Carnaíba",
    "Carnaubeira da Penha",
    "Carpina",
    "Caruaru",
    "Casinhas",
    "Catende",
    "Cedro",
    "Chã de Alegria",
    "Chã Grande",
    "Condado",
    "Correntes",
    "Cortês",
    "Cumaru",
    "Cupira",
    "Custódia",
    "Dormentes",
    "Escada",
    "Exu",
    "Feira Nova",
    "Ferreiros",
    "Flores",
    "Floresta",
    "Frei Miguelinho",
    "Gameleira",
    "Garanhuns",
    "Glória do Goitá",
    "Goiana",
    "Granito",
    "Gravatá",
    "Iati",
    "Ibimirim",
    "Ibirajuba",
    "Igarassu",
    "Iguaracy",
    "Ilha de Itamaracá",
    "Inajá",
    "Ingazeira",
    "Ipojuca",
    "Ipubi",
    "Itacuruba",
    "Itaíba",
    "Itambé",
    "Itapetim",
    "Itapissuma",
    "Itaquitinga",
    "Jaboatão dos Guararapes",
    "Jaqueira",
    "Jataúba",
    "Jatobá",
    "João Alfredo",
    "Joaquim Nabuco",
    "Jucati",
    "Jupi",
    "Jurema",
    "Lagoa de Itaenga",
    "Lagoa do Carro",
    "Lagoa do Ouro",
    "Lagoa dos Gatos",
    "Lagoa Grande",
    "Lajedo",
    "Limoeiro",
    "Macaparana",
    "Machados",
    "Manari",
    "Maraial",
    "Mirandiba",
    "Moreilândia",
    "Moreno",
    "Nazaré da Mata",
    "Olinda",
    "Orobó",
    "Orocó",
    "Ouricuri",
    "Palmares",
    "Palmeirina",
    "Panelas",
    "Paranatama",
    "Parnamirim",
    "Passira",
    "Paudalho",
    "Paulista",
    "Pedra",
    "Pesqueira",
    "Petrolândia",
    "Petrolina",
    "Poção",
    "Pombos",
    "Primavera",
    "Quipapá",
    "Quixaba",
    "Recife",
    "Riacho das Almas",
    "Ribeirão",
    "Rio Formoso",
    "Sairé",
    "Salgadinho",
    "Salgueiro",
    "Saloá",
    "Sanharó",
    "Santa Cruz",
    "Santa Cruz da Baixa Verde",
    "Santa Cruz do Capibaribe",
    "Santa Filomena",
    "Santa Maria da Boa Vista",
    "Santa Maria do Cambucá",
    "Santa Terezinha",
    "São Benedito do Sul",
    "São Bento do Una",
    "São Caetano",
    "São João",
    "São Joaquim do Monte",
    "São José da Coroa Grande",
    "São José do Belmonte",
    "São José do Egito",
    "São Lourenço da Mata",
    "São Vicente Férrer",
    "Serra Talhada",
    "Serrita",
    "Sertânia",
    "Sirinhaém",
    "Solidão",
    "Surubim",
    "Tabira",
    "Tacaimbó",
    "Tacaratu",
    "Tamandaré",
    "Taquaritinga do Norte",
    "Terezinha",
    "Terra Nova",
    "Timbaúba",
    "Toritama",
    "Tracunhaém",
    "Trindade",
    "Triunfo",
    "Tupanatinga",
    "Tuparetama",
    "Venturosa",
    "Verdejante",
    "Vertente do Lério",
    "Vertentes",
    "Vicência",
    "Vitória de Santo Antão",
    "Xexéu",
  ],
  Piauí: [
    "Acauã",
    "Agricolândia",
    "Água Branca",
    "Alagoinha do Piauí",
    "Alegrete do Piauí",
    "Alto Longá",
    "Altos",
    "Alvorada do Gurgueia",
    "Amarante",
    "Angical do Piauí",
    "Anísio de Abreu",
    "Antônio Almeida",
    "Aroazes",
    "Aroeiras do Itaim",
    "Arraial",
    "Assunção do Piauí",
    "Avelino Lopes",
    "Baixa Grande do Ribeiro",
    "Barra d'Alcântara",
    "Barras",
    "Barreiras do Piauí",
    "Barro Duro",
    "Batalha",
    "Bela Vista do Piauí",
    "Belém do Piauí",
    "Beneditinos",
    "Bertolínia",
    "Betânia do Piauí",
    "Boa Hora",
    "Bocaina",
    "Bom Jesus",
    "Bom Princípio do Piauí",
    "Bonfim do Piauí",
    "Boqueirão do Piauí",
    "Brasileira",
    "Brejo do Piauí",
    "Buriti dos Lopes",
    "Buriti dos Montes",
    "Cabeceiras do Piauí",
    "Cajazeiras do Piauí",
    "Cajueiro da Praia",
    "Caldeirão Grande do Piauí",
    "Campinas do Piauí",
    "Campo Alegre do Fidalgo",
    "Campo Grande do Piauí",
    "Campo Largo do Piauí",
    "Campo Maior",
    "Canavieira",
    "Canto do Buriti",
    "Capitão de Campos",
    "Capitão Gervásio Oliveira",
    "Caracol",
    "Caraúbas do Piauí",
    "Caridade do Piauí",
    "Castelo do Piauí",
    "Caxingó",
    "Cocal",
    "Cocal de Telha",
    "Cocal dos Alves",
    "Coivaras",
    "Colônia do Gurgueia",
    "Colônia do Piauí",
    "Conceição do Canindé",
    "Coronel José Dias",
    "Corrente",
    "Cristalândia do Piauí",
    "Cristino Castro",
    "Curimatá",
    "Currais",
    "Curralinhos",
    "Curral Novo do Piauí",
    "Demerval Lobão",
    "Dirceu Arcoverde",
    "Dom Expedito Lopes",
    "Domingos Mourão",
    "Dom Inocêncio",
    "Elesbão Veloso",
    "Eliseu Martins",
    "Esperantina",
    "Fartura do Piauí",
    "Flores do Piauí",
    "Floresta do Piauí",
    "Floriano",
    "Francinópolis",
    "Francisco Ayres",
    "Francisco Macedo",
    "Francisco Santos",
    "Fronteiras",
    "Geminiano",
    "Gilbués",
    "Guadalupe",
    "Guaribas",
    "Hugo Napoleão",
    "Ilha Grande",
    "Inhuma",
    "Ipiranga do Piauí",
    "Isaías Coelho",
    "Itainópolis",
    "Itaueira",
    "Jacobina do Piauí",
    "Jaicós",
    "Jardim do Mulato",
    "Jatobá do Piauí",
    "Jerumenha",
    "João Costa",
    "Joaquim Pires",
    "Joca Marques",
    "José de Freitas",
    "Juazeiro do Piauí",
    "Júlio Borges",
    "Jurema",
    "Lagoa Alegre",
    "Lagoa de São Francisco",
    "Lagoa do Barro do Piauí",
    "Lagoa do Piauí",
    "Lagoa do Sítio",
    "Lagoinha do Piauí",
    "Landri Sales",
    "Luís Correia",
    "Luzilândia",
    "Madeiro",
    "Manoel Emídio",
    "Marcolândia",
    "Marcos Parente",
    "Massapê do Piauí",
    "Matias Olímpio",
    "Miguel Alves",
    "Miguel Leão",
    "Milton Brandão",
    "Monsenhor Gil",
    "Monsenhor Hipólito",
    "Monte Alegre do Piauí",
    "Morro Cabeça no Tempo",
    "Morro do Chapéu do Piauí",
    "Murici dos Portelas",
    "Nazaré do Piauí",
    "Nazária",
    "Nossa Senhora de Nazaré",
    "Nossa Senhora dos Remédios",
    "Nova Santa Rita",
    "Novo Oriente do Piauí",
    "Novo Santo Antônio",
    "Oeiras",
    "Olho d'Água do Piauí",
    "Padre Marcos",
    "Paes Landim",
    "Pajeú do Piauí",
    "Palmeira do Piauí",
    "Palmeirais",
    "Paquetá",
    "Parnaguá",
    "Parnaíba",
    "Passagem Franca do Piauí",
    "Patos do Piauí",
    "Pau d'Arco do Piauí",
    "Paulistana",
    "Pavussu",
    "Pedro II",
    "Pedro Laurentino",
    "Picos",
    "Pimenteiras",
    "Pio IX",
    "Piracuruca",
    "Piripiri",
    "Porto",
    "Porto Alegre do Piauí",
    "Prata do Piauí",
    "Queimada Nova",
    "Redenção do Gurgueia",
    "Regeneração",
    "Riacho Frio",
    "Ribeira do Piauí",
    "Ribeiro Gonçalves",
    "Rio Grande do Piauí",
    "Santa Cruz do Piauí",
    "Santa Cruz dos Milagres",
    "Santa Filomena",
    "Santa Luz",
    "Santana do Piauí",
    "Santa Rosa do Piauí",
    "Santo Antônio de Lisboa",
    "Santo Antônio dos Milagres",
    "Santo Inácio do Piauí",
    "São Braz do Piauí",
    "São Félix do Piauí",
    "São Francisco de Assis do Piauí",
    "São Francisco do Piauí",
    "São Gonçalo do Gurgueia",
    "São Gonçalo do Piauí",
    "São João da Canabrava",
    "São João da Fronteira",
    "São João da Serra",
    "São João da Varjota",
    "São João do Arraial",
    "São João do Piauí",
    "São José do Divino",
    "São José do Peixe",
    "São José do Piauí",
    "São Julião",
    "São Lourenço do Piauí",
    "São Luís do Piauí",
    "São Miguel da Baixa Grande",
    "São Miguel do Fidalgo",
    "São Miguel do Tapuio",
    "São Pedro do Piauí",
    "São Raimundo Nonato",
    "Sebastião Barros",
    "Sebastião Leal",
    "Sigefredo Pacheco",
    "Simões",
    "Simplício Mendes",
    "Socorro do Piauí",
    "Sussuapara",
    "Tamboril do Piauí",
    "Tanque do Piauí",
    "Teresina",
    "União",
    "Uruçuí",
    "Valença do Piauí",
    "Várzea Branca",
    "Várzea Grande",
    "Vera Mendes",
    "Vila Nova do Piauí",
    "Wall Ferraz",
  ],
  "Rio de Janeiro": [
    "Angra dos Reis",
    "Aperibé",
    "Araruama",
    "Areal",
    "Armação dos Búzios",
    "Arraial do Cabo",
    "Barra do Piraí",
    "Barra Mansa",
    "Belford Roxo",
    "Bom Jardim",
    "Bom Jesus do Itabapoana",
    "Cabo Frio",
    "Cachoeiras de Macacu",
    "Cambuci",
    "Campos dos Goytacazes",
    "Cantagalo",
    "Carapebus",
    "Cardoso Moreira",
    "Carmo",
    "Casimiro de Abreu",
    "Comendador Levy Gasparian",
    "Conceição de Macabu",
    "Cordeiro",
    "Duas Barras",
    "Duque de Caxias",
    "Engenheiro Paulo de Frontin",
    "Guapimirim",
    "Iguaba Grande",
    "Itaboraí",
    "Itaguaí",
    "Italva",
    "Itaocara",
    "Itaperuna",
    "Itatiaia",
    "Japeri",
    "Laje do Muriaé",
    "Macaé",
    "Macuco",
    "Magé",
    "Mangaratiba",
    "Maricá",
    "Mendes",
    "Mesquita",
    "Miguel Pereira",
    "Miracema",
    "Natividade",
    "Nilópolis",
    "Niterói",
    "Nova Friburgo",
    "Nova Iguaçu",
    "Paracambi",
    "Paraíba do Sul",
    "Paraty",
    "Paty do Alferes",
    "Petrópolis",
    "Pinheiral",
    "Piraí",
    "Porciúncula",
    "Porto Real",
    "Quatis",
    "Queimados",
    "Quissamã",
    "Resende",
    "Rio Bonito",
    "Rio Claro",
    "Rio das Flores",
    "Rio das Ostras",
    "Rio de Janeiro",
    "Santa Maria Madalena",
    "Santo Antônio de Pádua",
    "São Fidélis",
    "São Francisco de Itabapoana",
    "São Gonçalo",
    "São João da Barra",
    "São João de Meriti",
    "São José de Ubá",
    "São José do Vale do Rio Preto",
    "São Pedro da Aldeia",
    "São Sebastião do Alto",
    "Sapucaia",
    "Saquarema",
    "Seropédica",
    "Silva Jardim",
    "Sumidouro",
    "Tanguá",
    "Teresópolis",
    "Trajano de Moraes",
    "Três Rios",
    "Valença",
    "Varre-Sai",
    "Vassouras",
    "Volta Redonda",
  ],
  "Rio Grande do Norte": [
    "Acari",
    "Afonso Bezerra",
    "Água Nova",
    "Alexandria",
    "Almino Afonso",
    "Alto do Rodrigues",
    "Angicos",
    "Antônio Martins",
    "Apodi",
    "Areia Branca",
    "Assu",
    "Baía Formosa",
    "Baraúna",
    "Barcelona",
    "Bento Fernandes",
    "Boa Saúde",
    "Bodó",
    "Bom Jesus",
    "Brejinho",
    "Caiçara do Norte",
    "Caiçara do Rio do Vento",
    "Caicó",
    "Campo Grande",
    "Campo Redondo",
    "Canguaretama",
    "Caraúbas",
    "Carnaúba dos Dantas",
    "Carnaubais",
    "Ceará-Mirim",
    "Cerro Corá",
    "Coronel Ezequiel",
    "Coronel João Pessoa",
    "Cruzeta",
    "Currais Novos",
    "Doutor Severiano",
    "Encanto",
    "Equador",
    "Espírito Santo",
    "Extremoz",
    "Felipe Guerra",
    "Fernando Pedroza",
    "Florânia",
    "Francisco Dantas",
    "Frutuoso Gomes",
    "Galinhos",
    "Goianinha",
    "Governador Dix-Sept Rosado",
    "Grossos",
    "Guamaré",
    "Ielmo Marinho",
    "Ipanguaçu",
    "Ipueira",
    "Itajá",
    "Itaú",
    "Jaçanã",
    "Jandaíra",
    "Janduís",
    "Japi",
    "Jardim de Angicos",
    "Jardim de Piranhas",
    "Jardim do Seridó",
    "João Câmara",
    "João Dias",
    "José da Penha",
    "Jucurutu",
    "Jundiá",
    "Lagoa d'Anta",
    "Lagoa de Pedras",
    "Lagoa de Velhos",
    "Lagoa Nova",
    "Lagoa Salgada",
    "Lajes",
    "Lajes Pintadas",
    "Lucrécia",
    "Luís Gomes",
    "Macaíba",
    "Macau",
    "Major Sales",
    "Marcelino Vieira",
    "Martins",
    "Maxaranguape",
    "Messias Targino",
    "Montanhas",
    "Monte Alegre",
    "Monte das Gameleiras",
    "Mossoró",
    "Natal",
    "Nísia Floresta",
    "Nova Cruz",
    "Olho d'Água do Borges",
    "Ouro Branco",
    "Paraná",
    "Paraú",
    "Parazinho",
    "Parelhas",
    "Parnamirim",
    "Passa-e-Fica",
    "Passagem",
    "Patu",
    "Pau dos Ferros",
    "Pedra Grande",
    "Pedra Preta",
    "Pedro Avelino",
    "Pedro Velho",
    "Pendências",
    "Pilões",
    "Poço Branco",
    "Portalegre",
    "Porto do Mangue",
    "Pureza",
    "Rafael Fernandes",
    "Rafael Godeiro",
    "Riacho da Cruz",
    "Riacho de Santana",
    "Riachuelo",
    "Rio do Fogo",
    "Rodolfo Fernandes",
    "Ruy Barbosa",
    "Santa Cruz",
    "Santa Maria",
    "Santana do Matos",
    "Santana do Seridó",
    "Santo Antônio",
    "São Bento do Norte",
    "São Bento do Trairi",
    "São Fernando",
    "São Francisco do Oeste",
    "São Gonçalo do Amarante",
    "São João do Sabugi",
    "São José de Mipibu",
    "São José do Campestre",
    "São José do Seridó",
    "São Miguel",
    "São Miguel do Gostoso",
    "São Paulo do Potengi",
    "São Pedro",
    "São Rafael",
    "São Tomé",
    "São Vicente",
    "Senador Elói de Souza",
    "Senador Georgino Avelino",
    "Serra Caiada",
    "Serra de São Bento",
    "Serra do Mel",
    "Serra Negra do Norte",
    "Serrinha",
    "Serrinha dos Pintos",
    "Severiano Melo",
    "Sítio Novo",
    "Taboleiro Grande",
    "Taipu",
    "Tangará",
    "Tenente Ananias",
    "Tenente Laurentino Cruz",
    "Tibau do Sul",
    "Tibau",
    "Timbaúba dos Batistas",
    "Touros",
    "Triunfo Potiguar",
    "Umarizal",
    "Upanema",
    "Várzea",
    "Venha-Ver",
    "Vera Cruz",
    "Viçosa",
    "Vila Flor",
  ],
  "Rio Grande do Sul": [
    "Aceguá",
    "Água Santa",
    "Agudo",
    "Ajuricaba",
    "Alecrim",
    "Alegrete",
    "Alegria",
    "Almirante Tamandaré do Sul",
    "Alpestre",
    "Alto Alegre",
    "Alto Feliz",
    "Alvorada",
    "Amaral Ferrador",
    "Ametista do Sul",
    "André da Rocha",
    "Anta Gorda",
    "Antônio Prado",
    "Arambaré",
    "Araricá",
    "Aratiba",
    "Arroio do Meio",
    "Arroio do Padre",
    "Arroio do Sal",
    "Arroio dos Ratos",
    "Arroio do Tigre",
    "Arroio Grande",
    "Arvorezinha",
    "Augusto Pestana",
    "Áurea",
    "Bagé",
    "Balneário Pinhal",
    "Barão",
    "Barão de Cotegipe",
    "Barão do Triunfo",
    "Barracão",
    "Barra do Guarita",
    "Barra do Quaraí",
    "Barra do Ribeiro",
    "Barra do Rio Azul",
    "Barra Funda",
    "Barros Cassal",
    "Benjamin Constant do Sul",
    "Bento Gonçalves",
    "Boa Vista das Missões",
    "Boa Vista do Buricá",
    "Boa Vista do Cadeado",
    "Boa Vista do Incra",
    "Boa Vista do Sul",
    "Bom Jesus",
    "Bom Princípio",
    "Bom Progresso",
    "Bom Retiro do Sul",
    "Boqueirão do Leão",
    "Bossoroca",
    "Bozano",
    "Braga",
    "Brochier",
    "Butiá",
    "Caçapava do Sul",
    "Cacequi",
    "Cachoeira do Sul",
    "Cachoeirinha",
    "Cacique Doble",
    "Caibaté",
    "Caiçara",
    "Camaquã",
    "Camargo",
    "Cambará do Sul",
    "Campestre da Serra",
    "Campina das Missões",
    "Campinas do Sul",
    "Campo Bom",
    "Campo Novo",
    "Campos Borges",
    "Candelária",
    "Cândido Godói",
    "Candiota",
    "Canela",
    "Canguçu",
    "Canoas",
    "Canudos do Vale",
    "Capão Bonito do Sul",
    "Capão da Canoa",
    "Capão do Cipó",
    "Capão do Leão",
    "Capela de Santana",
    "Capitão",
    "Capivari do Sul",
    "Caraá",
    "Carazinho",
    "Carlos Barbosa",
    "Carlos Gomes",
    "Casca",
    "Caseiros",
    "Catuípe",
    "Caxias do Sul",
    "Centenário",
    "Cerrito",
    "Cerro Branco",
    "Cerro Grande",
    "Cerro Grande do Sul",
    "Cerro Largo",
    "Chapada",
    "Charqueadas",
    "Charrua",
    "Chiapetta",
    "Chuí",
    "Chuvisca",
    "Cidreira",
    "Ciríaco",
    "Colinas",
    "Colorado",
    "Condor",
    "Constantina",
    "Coqueiro Baixo",
    "Coqueiros do Sul",
    "Coronel Barros",
    "Coronel Bicaco",
    "Coronel Pilar",
    "Cotiporã",
    "Coxilha",
    "Crissiumal",
    "Cristal",
    "Cristal do Sul",
    "Cruz Alta",
    "Cruzaltense",
    "Cruzeiro do Sul",
    "David Canabarro",
    "Derrubadas",
    "Dezesseis de Novembro",
    "Dilermando de Aguiar",
    "Dois Irmãos",
    "Dois Irmãos das Missões",
    "Dois Lajeados",
    "Dom Feliciano",
    "Dom Pedrito",
    "Dom Pedro de Alcântara",
    "Dona Francisca",
    "Doutor Maurício Cardoso",
    "Doutor Ricardo",
    "Eldorado do Sul",
    "Encantado",
    "Encruzilhada do Sul",
    "Engenho Velho",
    "Entre Ijuís",
    "Entre Rios do Sul",
    "Erebango",
    "Erechim",
    "Ernestina",
    "Erval Grande",
    "Erval Seco",
    "Esmeralda",
    "Esperança do Sul",
    "Espumoso",
    "Estação",
    "Estância Velha",
    "Esteio",
    "Estrela",
    "Estrela Velha",
    "Eugênio de Castro",
    "Fagundes Varela",
    "Farroupilha",
    "Faxinal do Soturno",
    "Faxinalzinho",
    "Fazenda Vilanova",
    "Feliz",
    "Flores da Cunha",
    "Floriano Peixoto",
    "Fontoura Xavier",
    "Formigueiro",
    "Forquetinha",
    "Fortaleza dos Valos",
    "Frederico Westphalen",
    "Garibaldi",
    "Garruchos",
    "Gaurama",
    "General Câmara",
    "Gentil",
    "Getúlio Vargas",
    "Giruá",
    "Glorinha",
    "Gramado",
    "Gramado dos Loureiros",
    "Gramado Xavier",
    "Gravataí",
    "Guabiju",
    "Guaíba",
    "Guaporé",
    "Guarani das Missões",
    "Harmonia",
    "Herval",
    "Herveiras",
    "Horizontina",
    "Hulha Negra",
    "Humaitá",
    "Ibarama",
    "Ibiaçá",
    "Ibiraiaras",
    "Ibirapuitã",
    "Ibirubá",
    "Igrejinha",
    "Ijuí",
    "Ilópolis",
    "Imbé",
    "Independência",
    "Inhacorá",
    "Ipê",
    "Ipiranga do Sul",
    "Iraí",
    "Itaara",
    "Itacurubi",
    "Itapuca",
    "Itaqui",
    "Itati",
    "Itatiba do Sul",
    "Ivorá",
    "Ivoti",
    "Jaboticaba",
    "Jacuizinho",
    "Jacutinga",
    "Jaguarão",
    "Jaguari",
    "Jaquirana",
    "Jari",
    "Jóia",
    "Júlio de Castilhos",
    "Lagoa Bonita do Sul",
    "Lagoa dos Três Cantos",
    "Lagoão",
    "Lagoa Vermelha",
    "Lajeado",
    "Lajeado do Bugre",
    "Lavras do Sul",
    "Liberato Salzano",
    "Lindolfo Collor",
    "Linha Nova",
    "Maçambará",
    "Machadinho",
    "Mampituba",
    "Manoel Viana",
    "Maquiné",
    "Maratá",
    "Marau",
    "Marcelino Ramos",
    "Mariana Pimentel",
    "Mariano Moro",
    "Marques de Souza",
    "Mata",
    "Mato Castelhano",
    "Mato Leitão",
    "Mato Queimado",
    "Maximiliano de Almeida",
    "Minas do Leão",
    "Miraguaí",
    "Montauri",
    "Monte Alegre dos Campos",
    "Monte Belo do Sul",
    "Montenegro",
    "Mormaço",
    "Morrinhos do Sul",
    "Morro Redondo",
    "Morro Reuter",
    "Mostardas",
    "Muçum",
    "Muitos Capões",
    "Muliterno",
    "Não-Me-Toque",
    "Nicolau Vergueiro",
    "Nonoai",
    "Nova Alvorada",
    "Nova Araçá",
    "Nova Bassano",
    "Nova Boa Vista",
    "Nova Bréscia",
    "Nova Candelária",
    "Nova Esperança do Sul",
    "Nova Hartz",
    "Nova Pádua",
    "Nova Palma",
    "Nova Petrópolis",
    "Nova Prata",
    "Nova Ramada",
    "Nova Roma do Sul",
    "Nova Santa Rita",
    "Novo Barreiro",
    "Novo Cabrais",
    "Novo Hamburgo",
    "Novo Machado",
    "Novo Tiradentes",
    "Novo Xingu",
    "Osório",
    "Paim Filho",
    "Palmares do Sul",
    "Palmeira das Missões",
    "Palmitinho",
    "Panambi",
    "Pantano Grande",
    "Paraí",
    "Paraíso do Sul",
    "Pareci Novo",
    "Parobé",
    "Passa-Sete",
    "Passo do Sobrado",
    "Passo Fundo",
    "Paulo Bento",
    "Paverama",
    "Pedras Altas",
    "Pedro Osório",
    "Pejuçara",
    "Pelotas",
    "Picada Café",
    "Pinhal",
    "Pinhal da Serra",
    "Pinhal Grande",
    "Pinheirinho do Vale",
    "Pinheiro Machado",
    "Pinto Bandeira",
    "Pirapó",
    "Piratini",
    "Planalto",
    "Poço das Antas",
    "Pontão",
    "Ponte Preta",
    "Portão",
    "Porto Alegre",
    "Porto Lucena",
    "Porto Mauá",
    "Porto Vera Cruz",
    "Porto Xavier",
    "Pouso Novo",
    "Presidente Lucena",
    "Progresso",
    "Protásio Alves",
    "Putinga",
    "Quaraí",
    "Quatro Irmãos",
    "Quevedos",
    "Quinze de Novembro",
    "Redentora",
    "Relvado",
    "Restinga Sêca",
    "Rio dos Índios",
    "Rio Grande",
    "Rio Pardo",
    "Riozinho",
    "Roca Sales",
    "Rodeio Bonito",
    "Rolador",
    "Rolante",
    "Ronda Alta",
    "Rondinha",
    "Roque Gonzales",
    "Rosário do Sul",
    "Sagrada Família",
    "Saldanha Marinho",
    "Salto do Jacuí",
    "Salvador das Missões",
    "Salvador do Sul",
    "Sananduva",
    "Santa Bárbara do Sul",
    "Santa Cecília do Sul",
    "Santa Clara do Sul",
    "Santa Cruz do Sul",
    "Santa Margarida do Sul",
    "Santa Maria",
    "Santa Maria do Herval",
    "Santana da Boa Vista",
    "Sant'Ana do Livramento",
    "Santa Rosa",
    "Santa Tereza",
    "Santa Vitória do Palmar",
    "Santiago",
    "Santo Ângelo",
    "Santo Antônio da Patrulha",
    "Santo Antônio das Missões",
    "Santo Antônio do Palma",
    "Santo Antônio do Planalto",
    "Santo Augusto",
    "Santo Cristo",
    "Santo Expedito do Sul",
    "São Borja",
    "São Domingos do Sul",
    "São Francisco de Assis",
    "São Francisco de Paula",
    "São Gabriel",
    "São Jerônimo",
    "São João da Urtiga",
    "São João do Polêsine",
    "São Jorge",
    "São José das Missões",
    "São José do Herval",
    "São José do Hortêncio",
    "São José do Inhacorá",
    "São José do Norte",
    "São José do Ouro",
    "São José dos Ausentes",
    "São José do Sul",
    "São Leopoldo",
    "São Lourenço do Sul",
    "São Luiz Gonzaga",
    "São Marcos",
    "São Martinho",
    "São Martinho da Serra",
    "São Miguel das Missões",
    "São Nicolau",
    "São Paulo das Missões",
    "São Pedro da Serra",
    "São Pedro das Missões",
    "São Pedro do Butiá",
    "São Pedro do Sul",
    "São Sebastião do Caí",
    "São Sepé",
    "São Valentim",
    "São Valentim do Sul",
    "São Valério do Sul",
    "São Vendelino",
    "São Vicente do Sul",
    "Sapiranga",
    "Sapucaia do Sul",
    "Sarandi",
    "Seberi",
    "Sede Nova",
    "Segredo",
    "Selbach",
    "Senador Salgado Filho",
    "Sentinela do Sul",
    "Serafina Corrêa",
    "Sério",
    "Sertão",
    "Sertão Santana",
    "Sete de Setembro",
    "Severiano de Almeida",
    "Silveira Martins",
    "Sinimbu",
    "Sobradinho",
    "Soledade",
    "Tabaí",
    "Tapejara",
    "Tapera",
    "Tapes",
    "Taquara",
    "Taquari",
    "Taquaruçu do Sul",
    "Tavares",
    "Tenente Portela",
    "Terra de Areia",
    "Teutônia",
    "Tio Hugo",
    "Tiradentes do Sul",
    "Toropi",
    "Torres",
    "Tramandaí",
    "Travesseiro",
    "Três Arroios",
    "Três Cachoeiras",
    "Três Coroas",
    "Três de Maio",
    "Três Forquilhas",
    "Três Palmeiras",
    "Três Passos",
    "Trindade do Sul",
    "Triunfo",
    "Tucunduva",
    "Tunas",
    "Tupanci do Sul",
    "Tupanciretã",
    "Tupandi",
    "Tuparendi",
    "Turuçu",
    "Ubiretama",
    "União da Serra",
    "Unistalda",
    "Uruguaiana",
    "Vacaria",
    "Vale do Sol",
    "Vale Real",
    "Vale Verde",
    "Vanini",
    "Venâncio Aires",
    "Vera Cruz",
    "Veranópolis",
    "Vespasiano Corrêa",
    "Viadutos",
    "Viamão",
    "Vicente Dutra",
    "Victor Graeff",
    "Vila Flores",
    "Vila Lângaro",
    "Vila Maria",
    "Vila Nova do Sul",
    "Vista Alegre",
    "Vista Alegre do Prata",
    "Vista Gaúcha",
    "Vitória das Missões",
    "Westfália",
    "Xangri-lá",
  ],
  Rondônia: [
    "Alta Floresta d'Oeste",
    "Alto Alegre dos Parecis",
    "Alto Paraíso",
    "Alvorada d'Oeste",
    "Ariquemes",
    "Buritis",
    "Cabixi",
    "Cacaulândia",
    "Cacoal",
    "Campo Novo de Rondônia",
    "Candeias do Jamari",
    "Castanheiras",
    "Cerejeiras",
    "Chupinguaia",
    "Colorado do Oeste",
    "Corumbiara",
    "Costa Marques",
    "Cujubim",
    "Espigão d'Oeste",
    "Governador Jorge Teixeira",
    "Guajará-Mirim",
    "Itapuã do Oeste",
    "Jaru",
    "Ji-Paraná",
    "Machadinho d'Oeste",
    "Ministro Andreazza",
    "Mirante da Serra",
    "Monte Negro",
    "Nova Brasilândia d'Oeste",
    "Nova Mamoré",
    "Nova União",
    "Novo Horizonte do Oeste",
    "Ouro Preto do Oeste",
    "Parecis",
    "Pimenta Bueno",
    "Pimenteiras do Oeste",
    "Porto Velho",
    "Presidente Médici",
    "Primavera de Rondônia",
    "Rio Crespo",
    "Rolim de Moura",
    "Santa Luzia d'Oeste",
    "São Felipe d'Oeste",
    "São Francisco do Guaporé",
    "São Miguel do Guaporé",
    "Seringueiras",
    "Teixeirópolis",
    "Theobroma",
    "Urupá",
    "Vale do Anari",
    "Vale do Paraíso",
    "Vilhena",
  ],
  Roraima: [
    "Alto Alegre",
    "Amajari",
    "Boa Vista",
    "Bonfim",
    "Cantá",
    "Caracaraí",
    "Caroebe",
    "Iracema",
    "Mucajaí",
    "Normandia",
    "Pacaraima",
    "Rorainópolis",
    "São João da Baliza",
    "São Luiz",
    "Uiramutã",
  ],
  "Santa Catarina": [
    "Abdon Batista",
    "Abelardo Luz",
    "Agrolândia",
    "Agronômica",
    "Água Doce",
    "Águas de Chapecó",
    "Águas Frias",
    "Águas Mornas",
    "Alfredo Wagner",
    "Alto Bela Vista",
    "Anchieta",
    "Angelina",
    "Anita Garibaldi",
    "Anitápolis",
    "Antônio Carlos",
    "Apiúna",
    "Arabutã",
    "Araquari",
    "Araranguá",
    "Armazém",
    "Arroio Trinta",
    "Arvoredo",
    "Ascurra",
    "Atalanta",
    "Aurora",
    "Balneário Arroio do Silva",
    "Balneário Barra do Sul",
    "Balneário Camboriú",
    "Balneário Gaivota",
    "Balneário Piçarras",
    "Balneário Rincão",
    "Bandeirante",
    "Barra Bonita",
    "Barra Velha",
    "Bela Vista do Toldo",
    "Belmonte",
    "Benedito Novo",
    "Biguaçu",
    "Blumenau",
    "Bocaina do Sul",
    "Bombinhas",
    "Bom Jardim da Serra",
    "Bom Jesus",
    "Bom Jesus do Oeste",
    "Bom Retiro",
    "Botuverá",
    "Braço do Norte",
    "Braço do Trombudo",
    "Brunópolis",
    "Brusque",
    "Caçador",
    "Caibi",
    "Calmon",
    "Camboriú",
    "Campo Alegre",
    "Campo Belo do Sul",
    "Campo Erê",
    "Campos Novos",
    "Canelinha",
    "Canoinhas",
    "Capão Alto",
    "Capinzal",
    "Capivari de Baixo",
    "Catanduvas",
    "Caxambu do Sul",
    "Celso Ramos",
    "Cerro Negro",
    "Chapadão do Lageado",
    "Chapecó",
    "Cocal do Sul",
    "Concórdia",
    "Cordilheira Alta",
    "Coronel Freitas",
    "Coronel Martins",
    "Correia Pinto",
    "Corupá",
    "Criciúma",
    "Cunha Porã",
    "Cunhataí",
    "Curitibanos",
    "Descanso",
    "Dionísio Cerqueira",
    "Dona Emma",
    "Doutor Pedrinho",
    "Entre Rios",
    "Ermo",
    "Erval Velho",
    "Faxinal dos Guedes",
    "Flor do Sertão",
    "Florianópolis",
    "Formosa do Sul",
    "Forquilhinha",
    "Fraiburgo",
    "Frei Rogério",
    "Galvão",
    "Garopaba",
    "Garuva",
    "Gaspar",
    "Governador Celso Ramos",
    "Grão-Pará",
    "Gravatal",
    "Guabiruba",
    "Guaraciaba",
    "Guaramirim",
    "Guarujá do Sul",
    "Guatambu",
    "Herval d'Oeste",
    "Ibiam",
    "Ibicaré",
    "Ibirama",
    "Içara",
    "Ilhota",
    "Imaruí",
    "Imbituba",
    "Imbuia",
    "Indaial",
    "Iomerê",
    "Ipira",
    "Iporã do Oeste",
    "Ipuaçu",
    "Ipumirim",
    "Iraceminha",
    "Irani",
    "Irati",
    "Irineópolis",
    "Itá",
    "Itaiópolis",
    "Itajaí",
    "Itapema",
    "Itapiranga",
    "Itapoá",
    "Ituporanga",
    "Jaborá",
    "Jacinto Machado",
    "Jaguaruna",
    "Jaraguá do Sul",
    "Jardinópolis",
    "Joaçaba",
    "Joinville",
    "José Boiteux",
    "Jupiá",
    "Lacerdópolis",
    "Lages",
    "Laguna",
    "Lajeado Grande",
    "Laurentino",
    "Lauro Müller",
    "Lebon Régis",
    "Leoberto Leal",
    "Lindóia do Sul",
    "Lontras",
    "Luiz Alves",
    "Luzerna",
    "Macieira",
    "Mafra",
    "Major Gercino",
    "Major Vieira",
    "Maracajá",
    "Maravilha",
    "Marema",
    "Massaranduba",
    "Matos Costa",
    "Meleiro",
    "Mirim Doce",
    "Modelo",
    "Mondaí",
    "Monte Carlo",
    "Monte Castelo",
    "Morro da Fumaça",
    "Morro Grande",
    "Navegantes",
    "Nova Erechim",
    "Nova Itaberaba",
    "Nova Trento",
    "Nova Veneza",
    "Novo Horizonte",
    "Orleans",
    "Otacílio Costa",
    "Ouro",
    "Ouro Verde",
    "Paial",
    "Painel",
    "Palhoça",
    "Palma Sola",
    "Palmeira",
    "Palmitos",
    "Papanduva",
    "Paraíso",
    "Passo de Torres",
    "Passos Maia",
    "Paulo Lopes",
    "Pedras Grandes",
    "Penha",
    "Peritiba",
    "Pescaria Brava",
    "Petrolândia",
    "Pinhalzinho",
    "Pinheiro Preto",
    "Piratuba",
    "Planalto Alegre",
    "Pomerode",
    "Ponte Alta",
    "Ponte Alta do Norte",
    "Ponte Serrada",
    "Porto Belo",
    "Porto União",
    "Pouso Redondo",
    "Praia Grande",
    "Presidente Castello Branco",
    "Presidente Getúlio",
    "Presidente Nereu",
    "Princesa",
    "Quilombo",
    "Rancho Queimado",
    "Rio das Antas",
    "Rio do Campo",
    "Rio do Oeste",
    "Rio dos Cedros",
    "Rio do Sul",
    "Rio Fortuna",
    "Rio Negrinho",
    "Rio Rufino",
    "Riqueza",
    "Rodeio",
    "Romelândia",
    "Salete",
    "Saltinho",
    "Salto Veloso",
    "Sangão",
    "Santa Cecília",
    "Santa Helena",
    "Santa Rosa de Lima",
    "Santa Rosa do Sul",
    "Santa Terezinha",
    "Santa Terezinha do Progresso",
    "Santiago do Sul",
    "Santo Amaro da Imperatriz",
    "São Bento do Sul",
    "São Bernardino",
    "São Bonifácio",
    "São Carlos",
    "São Cristóvão do Sul",
    "São Domingos",
    "São Francisco do Sul",
    "São João Batista",
    "São João do Itaperiú",
    "São João do Oeste",
    "São João do Sul",
    "São Joaquim",
    "São José",
    "São José do Cedro",
    "São José do Cerrito",
    "São Lourenço do Oeste",
    "São Ludgero",
    "São Martinho",
    "São Miguel da Boa Vista",
    "São Miguel do Oeste",
    "São Pedro de Alcântara",
    "Saudades",
    "Schroeder",
    "Seara",
    "Serra Alta",
    "Siderópolis",
    "Sombrio",
    "Sul Brasil",
    "Taió",
    "Tangará",
    "Tigrinhos",
    "Tijucas",
    "Timbé do Sul",
    "Timbó",
    "Timbó Grande",
    "Três Barras",
    "Treviso",
    "Treze de Maio",
    "Treze Tílias",
    "Trombudo Central",
    "Tubarão",
    "Tunápolis",
    "Turvo",
    "União do Oeste",
    "Urubici",
    "Urupema",
    "Urussanga",
    "Vargeão",
    "Vargem",
    "Vargem Bonita",
    "Vidal Ramos",
    "Videira",
    "Vitor Meireles",
    "Witmarsum",
    "Xanxerê",
    "Xavantina",
    "Xaxim",
    "Zortéa",
  ],
  "São Paulo": [
    "Adamantina",
    "Adolfo",
    "Aguaí",
    "Águas da Prata",
    "Águas de Lindóia",
    "Águas de Santa Bárbara",
    "Águas de São Pedro",
    "Agudos",
    "Alambari",
    "Alfredo Marcondes",
    "Altair",
    "Altinópolis",
    "Alto Alegre",
    "Alumínio",
    "Álvares Florence",
    "Álvares Machado",
    "Álvaro de Carvalho",
    "Alvinlândia",
    "Americana",
    "Américo Brasiliense",
    "Américo de Campos",
    "Amparo",
    "Analândia",
    "Andradina",
    "Angatuba",
    "Anhembi",
    "Anhumas",
    "Aparecida",
    "Aparecida d'Oeste",
    "Apiaí",
    "Araçariguama",
    "Araçatuba",
    "Araçoiaba da Serra",
    "Aramina",
    "Arandu",
    "Arapeí",
    "Araraquara",
    "Araras",
    "Arco-Íris",
    "Arealva",
    "Areias",
    "Areiópolis",
    "Ariranha",
    "Artur Nogueira",
    "Arujá",
    "Aspásia",
    "Assis",
    "Atibaia",
    "Auriflama",
    "Avaí",
    "Avanhandava",
    "Avaré",
    "Bady Bassitt",
    "Balbinos",
    "Bálsamo",
    "Bananal",
    "Barão de Antonina",
    "Barbosa",
    "Bariri",
    "Barra Bonita",
    "Barra do Chapéu",
    "Barra do Turvo",
    "Barretos",
    "Barrinha",
    "Barueri",
    "Bastos",
    "Batatais",
    "Bauru",
    "Bebedouro",
    "Bento de Abreu",
    "Bernardino de Campos",
    "Bertioga",
    "Bilac",
    "Birigui",
    "Biritiba Mirim",
    "Boa Esperança do Sul",
    "Bocaina",
    "Bofete",
    "Boituva",
    "Bom Jesus dos Perdões",
    "Bom Sucesso de Itararé",
    "Borá",
    "Boraceia",
    "Borborema",
    "Borebi",
    "Botucatu",
    "Bragança Paulista",
    "Braúna",
    "Brejo Alegre",
    "Brodowski",
    "Brotas",
    "Buri",
    "Buritama",
    "Buritizal",
    "Cabrália Paulista",
    "Cabreúva",
    "Caçapava",
    "Cachoeira Paulista",
    "Caconde",
    "Cafelândia",
    "Caiabu",
    "Caieiras",
    "Caiuá",
    "Cajamar",
    "Cajati",
    "Cajobi",
    "Cajuru",
    "Campina do Monte Alegre",
    "Campinas",
    "Campo Limpo Paulista",
    "Campos do Jordão",
    "Campos Novos Paulista",
    "Cananéia",
    "Canas",
    "Cândido Mota",
    "Cândido Rodrigues",
    "Canitar",
    "Capão Bonito",
    "Capela do Alto",
    "Capivari",
    "Caraguatatuba",
    "Carapicuíba",
    "Cardoso",
    "Casa Branca",
    "Cássia dos Coqueiros",
    "Castilho",
    "Catanduva",
    "Catiguá",
    "Cedral",
    "Cerqueira César",
    "Cerquilho",
    "Cesário Lange",
    "Charqueada",
    "Chavantes",
    "Clementina",
    "Colina",
    "Colômbia",
    "Conchal",
    "Conchas",
    "Cordeirópolis",
    "Coroados",
    "Coronel Macedo",
    "Corumbataí",
    "Cosmópolis",
    "Cosmorama",
    "Cotia",
    "Cravinhos",
    "Cristais Paulista",
    "Cruzália",
    "Cruzeiro",
    "Cubatão",
    "Cunha",
    "Descalvado",
    "Diadema",
    "Dirce Reis",
    "Divinolândia",
    "Dobrada",
    "Dois Córregos",
    "Dolcinópolis",
    "Dourado",
    "Dracena",
    "Duartina",
    "Dumont",
    "Echaporã",
    "Eldorado",
    "Elias Fausto",
    "Elisiário",
    "Embaúba",
    "Embu das Artes",
    "Embu-Guaçu",
    "Emilianópolis",
    "Engenheiro Coelho",
    "Espírito Santo do Pinhal",
    "Espírito Santo do Turvo",
    "Estiva Gerbi",
    "Estrela d'Oeste",
    "Estrela do Norte",
    "Euclides da Cunha Paulista",
    "Fartura",
    "Fernandópolis",
    "Fernando Prestes",
    "Fernão",
    "Ferraz de Vasconcelos",
    "Flora Rica",
    "Floreal",
    "Flórida Paulista",
    "Florínea",
    "Franca",
    "Francisco Morato",
    "Franco da Rocha",
    "Gabriel Monteiro",
    "Gália",
    "Garça",
    "Gastão Vidigal",
    "Gavião Peixoto",
    "General Salgado",
    "Getulina",
    "Glicério",
    "Guaiçara",
    "Guaimbê",
    "Guaíra",
    "Guapiaçu",
    "Guapiara",
    "Guará",
    "Guaraçaí",
    "Guaraci",
    "Guarani d'Oeste",
    "Guarantã",
    "Guararapes",
    "Guararema",
    "Guaratinguetá",
    "Guareí",
    "Guariba",
    "Guarujá",
    "Guarulhos",
    "Guatapará",
    "Guzolândia",
    "Herculândia",
    "Holambra",
    "Hortolândia",
    "Iacanga",
    "Iacri",
    "Iaras",
    "Ibaté",
    "Ibirá",
    "Ibirarema",
    "Ibitinga",
    "Ibiúna",
    "Icém",
    "Iepê",
    "Igaraçu do Tietê",
    "Igarapava",
    "Igaratá",
    "Iguape",
    "Ilhabela",
    "Ilha Comprida",
    "Ilha Solteira",
    "Indaiatuba",
    "Indiana",
    "Indiaporã",
    "Inúbia Paulista",
    "Ipaussu",
    "Iperó",
    "Ipeúna",
    "Ipiguá",
    "Iporanga",
    "Ipuã",
    "Iracemápolis",
    "Irapuã",
    "Irapuru",
    "Itaberá",
    "Itaí",
    "Itajobi",
    "Itaju",
    "Itanhaém",
    "Itaoca",
    "Itapecerica da Serra",
    "Itapetininga",
    "Itapeva",
    "Itapevi",
    "Itapira",
    "Itapirapuã Paulista",
    "Itápolis",
    "Itaporanga",
    "Itapuí",
    "Itapura",
    "Itaquaquecetuba",
    "Itararé",
    "Itariri",
    "Itatiba",
    "Itatinga",
    "Itirapina",
    "Itirapuã",
    "Itobi",
    "Itu",
    "Itupeva",
    "Ituverava",
    "Jaborandi",
    "Jaboticabal",
    "Jacareí",
    "Jaci",
    "Jacupiranga",
    "Jaguariúna",
    "Jales",
    "Jambeiro",
    "Jandira",
    "Jardinópolis",
    "Jarinu",
    "Jaú",
    "Jeriquara",
    "Joanópolis",
    "João Ramalho",
    "José Bonifácio",
    "Júlio Mesquita",
    "Jumirim",
    "Jundiaí",
    "Junqueirópolis",
    "Juquiá",
    "Juquitiba",
    "Lagoinha",
    "Laranjal Paulista",
    "Lavínia",
    "Lavrinhas",
    "Leme",
    "Lençóis Paulista",
    "Limeira",
    "Lindóia",
    "Lins",
    "Lorena",
    "Lourdes",
    "Louveira",
    "Lucélia",
    "Lucianópolis",
    "Luiz Antônio",
    "Luisiânia",
    "Lupércio",
    "Lutécia",
    "Macatuba",
    "Macaubal",
    "Macedônia",
    "Magda",
    "Mairinque",
    "Mairiporã",
    "Manduri",
    "Marabá Paulista",
    "Maracaí",
    "Marapoama",
    "Mariápolis",
    "Marília",
    "Marinópolis",
    "Martinópolis",
    "Matão",
    "Mauá",
    "Mendonça",
    "Meridiano",
    "Mesópolis",
    "Miguelópolis",
    "Mineiros do Tietê",
    "Miracatu",
    "Mira Estrela",
    "Mirandópolis",
    "Mirante do Paranapanema",
    "Mirassol",
    "Mirassolândia",
    "Mococa",
    "Mogi das Cruzes",
    "Mogi Guaçu",
    "Mogi Mirim",
    "Mombuca",
    "Monções",
    "Mongaguá",
    "Monte Alegre do Sul",
    "Monte Alto",
    "Monte Aprazível",
    "Monte Azul Paulista",
    "Monte Castelo",
    "Monteiro Lobato",
    "Monte Mor",
    "Morro Agudo",
    "Morungaba",
    "Motuca",
    "Murutinga do Sul",
    "Nantes",
    "Narandiba",
    "Natividade da Serra",
    "Nazaré Paulista",
    "Neves Paulista",
    "Nhandeara",
    "Nipoã",
    "Nova Aliança",
    "Nova Campina",
    "Nova Canaã Paulista",
    "Nova Castilho",
    "Nova Europa",
    "Nova Granada",
    "Nova Guataporanga",
    "Nova Independência",
    "Novais",
    "Nova Luzitânia",
    "Nova Odessa",
    "Novo Horizonte",
    "Nuporanga",
    "Ocauçu",
    "Óleo",
    "Olímpia",
    "Onda Verde",
    "Oriente",
    "Orindiúva",
    "Orlândia",
    "Osasco",
    "Oscar Bressane",
    "Osvaldo Cruz",
    "Ourinhos",
    "Ouroeste",
    "Ouro Verde",
    "Pacaembu",
    "Palestina",
    "Palmares Paulista",
    "Palmeira d'Oeste",
    "Palmital",
    "Panorama",
    "Paraguaçu Paulista",
    "Paraibuna",
    "Paraíso",
    "Paranapanema",
    "Paranapuã",
    "Parapuã",
    "Pardinho",
    "Pariquera-Açu",
    "Parisi",
    "Patrocínio Paulista",
    "Paulicéia",
    "Paulínia",
    "Paulistânia",
    "Paulo de Faria",
    "Pederneiras",
    "Pedra Bela",
    "Pedranópolis",
    "Pedregulho",
    "Pedreira",
    "Pedrinhas Paulista",
    "Pedro de Toledo",
    "Penápolis",
    "Pereira Barreto",
    "Pereiras",
    "Peruíbe",
    "Piacatu",
    "Piedade",
    "Pilar do Sul",
    "Pindamonhangaba",
    "Pindorama",
    "Pinhalzinho",
    "Piquerobi",
    "Piquete",
    "Piracaia",
    "Piracicaba",
    "Piraju",
    "Pirajuí",
    "Pirangi",
    "Pirapora do Bom Jesus",
    "Pirapozinho",
    "Pirassununga",
    "Piratininga",
    "Pitangueiras",
    "Planalto",
    "Platina",
    "Poá",
    "Poloni",
    "Pompeia",
    "Pongaí",
    "Pontal",
    "Pontalinda",
    "Pontes Gestal",
    "Populina",
    "Porangaba",
    "Porto Feliz",
    "Porto Ferreira",
    "Potim",
    "Potirendaba",
    "Pracinha",
    "Pradópolis",
    "Praia Grande",
    "Pratânia",
    "Presidente Alves",
    "Presidente Bernardes",
    "Presidente Epitácio",
    "Presidente Prudente",
    "Presidente Venceslau",
    "Promissão",
    "Quadra",
    "Quatá",
    "Queiroz",
    "Queluz",
    "Quintana",
    "Rafard",
    "Rancharia",
    "Redenção da Serra",
    "Regente Feijó",
    "Reginópolis",
    "Registro",
    "Restinga",
    "Ribeira",
    "Ribeirão Bonito",
    "Ribeirão Branco",
    "Ribeirão Corrente",
    "Ribeirão dos Índios",
    "Ribeirão do Sul",
    "Ribeirão Grande",
    "Ribeirão Pires",
    "Ribeirão Preto",
    "Rifaina",
    "Rincão",
    "Rinópolis",
    "Rio Claro",
    "Rio das Pedras",
    "Rio Grande da Serra",
    "Riolândia",
    "Riversul",
    "Rosana",
    "Roseira",
    "Rubiácea",
    "Rubineia",
    "Sabino",
    "Sagres",
    "Sales",
    "Sales Oliveira",
    "Salesópolis",
    "Salmourão",
    "Saltinho",
    "Salto",
    "Salto de Pirapora",
    "Salto Grande",
    "Sandovalina",
    "Santa Adélia",
    "Santa Albertina",
    "Santa Bárbara d'Oeste",
    "Santa Branca",
    "Santa Clara d'Oeste",
    "Santa Cruz da Conceição",
    "Santa Cruz da Esperança",
    "Santa Cruz das Palmeiras",
    "Santa Cruz do Rio Pardo",
    "Santa Ernestina",
    "Santa Fé do Sul",
    "Santa Gertrudes",
    "Santa Isabel",
    "Santa Lúcia",
    "Santa Maria da Serra",
    "Santa Mercedes",
    "Santana da Ponte Pensa",
    "Santana de Parnaíba",
    "Santa Rita d'Oeste",
    "Santa Rita do Passa Quatro",
    "Santa Rosa de Viterbo",
    "Santa Salete",
    "Santo Anastácio",
    "Santo André",
    "Santo Antônio da Alegria",
    "Santo Antônio de Posse",
    "Santo Antônio do Aracanguá",
    "Santo Antônio do Jardim",
    "Santo Antônio do Pinhal",
    "Santo Expedito",
    "Santópolis do Aguapeí",
    "Santos",
    "São Bento do Sapucaí",
    "São Bernardo do Campo",
    "São Caetano do Sul",
    "São Carlos",
    "São Francisco",
    "São João da Boa Vista",
    "São João das Duas Pontes",
    "São João de Iracema",
    "São João do Pau-d'Alho",
    "São Joaquim da Barra",
    "São José da Bela Vista",
    "São José do Barreiro",
    "São José do Rio Pardo",
    "São José do Rio Preto",
    "São José dos Campos",
    "São Lourenço da Serra",
    "São Luiz do Paraitinga",
    "São Manuel",
    "São Miguel Arcanjo",
    "São Paulo",
    "São Pedro",
    "São Pedro do Turvo",
    "São Roque",
    "São Sebastião",
    "São Sebastião da Grama",
    "São Simão",
    "São Vicente",
    "Sarapuí",
    "Sarutaiá",
    "Sebastianópolis do Sul",
    "Serra Azul",
    "Serrana",
    "Serra Negra",
    "Sertãozinho",
    "Sete Barras",
    "Severínia",
    "Silveiras",
    "Socorro",
    "Sorocaba",
    "Sud Mennucci",
    "Sumaré",
    "Suzanápolis",
    "Suzano",
    "Tabapuã",
    "Tabatinga",
    "Taboão da Serra",
    "Taciba",
    "Taguaí",
    "Taiaçu",
    "Taiuva",
    "Tambaú",
    "Tanabi",
    "Tapiraí",
    "Tapiratiba",
    "Taquaral",
    "Taquaritinga",
    "Taquarituba",
    "Taquarivaí",
    "Tarabai",
    "Tarumã",
    "Tatuí",
    "Taubaté",
    "Tejupá",
    "Teodoro Sampaio",
    "Terra Roxa",
    "Tietê",
    "Timburi",
    "Torre de Pedra",
    "Torrinha",
    "Trabiju",
    "Tremembé",
    "Três Fronteiras",
    "Tuiuti",
    "Tupã",
    "Tupi Paulista",
    "Turiúba",
    "Turmalina",
    "Ubarana",
    "Ubatuba",
    "Ubirajara",
    "Uchoa",
    "União Paulista",
    "Urânia",
    "Uru",
    "Urupês",
    "Valentim Gentil",
    "Valinhos",
    "Valparaíso",
    "Vargem",
    "Vargem Grande do Sul",
    "Vargem Grande Paulista",
    "Várzea Paulista",
    "Vera Cruz",
    "Vinhedo",
    "Viradouro",
    "Vista Alegre do Alto",
    "Vitória Brasil",
    "Votorantim",
    "Votuporanga",
    "Zacarias",
  ],
  Sergipe: [
    "Amparo do São Francisco",
    "Aquidabã",
    "Aracaju",
    "Arauá",
    "Areia Branca",
    "Barra dos Coqueiros",
    "Boquim",
    "Brejo Grande",
    "Campo do Brito",
    "Canhoba",
    "Canindé de São Francisco",
    "Capela",
    "Carira",
    "Carmópolis",
    "Cedro de São João",
    "Cristinápolis",
    "Cumbe",
    "Divina Pastora",
    "Estância",
    "Feira Nova",
    "Frei Paulo",
    "Gararu",
    "General Maynard",
    "Graccho Cardoso",
    "Ilha das Flores",
    "Indiaroba",
    "Itabaiana",
    "Itabaianinha",
    "Itabi",
    "Itaporanga d'Ajuda",
    "Japaratuba",
    "Japoatã",
    "Lagarto",
    "Laranjeiras",
    "Macambira",
    "Malhada dos Bois",
    "Malhador",
    "Maruim",
    "Moita Bonita",
    "Monte Alegre de Sergipe",
    "Muribeca",
    "Neópolis",
    "Nossa Senhora Aparecida",
    "Nossa Senhora da Glória",
    "Nossa Senhora das Dores",
    "Nossa Senhora de Lourdes",
    "Nossa Senhora do Socorro",
    "Pacatuba",
    "Pedra Mole",
    "Pedrinhas",
    "Pinhão",
    "Pirambu",
    "Poço Redondo",
    "Poço Verde",
    "Porto da Folha",
    "Propriá",
    "Riachão do Dantas",
    "Riachuelo",
    "Ribeirópolis",
    "Rosário do Catete",
    "Salgado",
    "Santa Luzia do Itanhi",
    "Santana do São Francisco",
    "Santa Rosa de Lima",
    "Santo Amaro das Brotas",
    "São Cristóvão",
    "São Domingos",
    "São Francisco",
    "São Miguel do Aleixo",
    "Simão Dias",
    "Siriri",
    "Telha",
    "Tobias Barreto",
    "Tomar do Geru",
    "Umbaúba",
  ],
  Tocantins: [
    "Abreulândia",
    "Aguiarnópolis",
    "Aliança do Tocantins",
    "Almas",
    "Alvorada",
    "Ananás",
    "Angico",
    "Aparecida do Rio Negro",
    "Aragominas",
    "Araguacema",
    "Araguaçu",
    "Araguaína",
    "Araguanã",
    "Araguatins",
    "Arapoema",
    "Arraias",
    "Augustinópolis",
    "Aurora do Tocantins",
    "Axixá do Tocantins",
    "Babaçulândia",
    "Bandeirantes do Tocantins",
    "Barra do Ouro",
    "Barrolândia",
    "Bernardo Sayão",
    "Bom Jesus do Tocantins",
    "Brasilândia do Tocantins",
    "Brejinho de Nazaré",
    "Buriti do Tocantins",
    "Cachoeirinha",
    "Campos Lindos",
    "Cariri do Tocantins",
    "Carmolândia",
    "Carrasco Bonito",
    "Caseara",
    "Centenário",
    "Chapada da Natividade",
    "Chapada de Areia",
    "Colinas do Tocantins",
    "Colméia",
    "Combinado",
    "Conceição do Tocantins",
    "Couto Magalhães",
    "Cristalândia",
    "Crixás do Tocantins",
    "Darcinópolis",
    "Dianópolis",
    "Divinópolis do Tocantins",
    "Dois Irmãos do Tocantins",
    "Dueré",
    "Esperantina",
    "Fátima",
    "Figueirópolis",
    "Filadélfia",
    "Formoso do Araguaia",
    "Goianorte",
    "Goiatins",
    "Guaraí",
    "Gurupi",
    "Ipueiras",
    "Itacajá",
    "Itaguatins",
    "Itapiratins",
    "Itaporã do Tocantins",
    "Jaú do Tocantins",
    "Juarina",
    "Lagoa da Confusão",
    "Lagoa do Tocantins",
    "Lajeado",
    "Lavandeira",
    "Lizarda",
    "Luzinópolis",
    "Marianópolis do Tocantins",
    "Mateiros",
    "Maurilândia do Tocantins",
    "Miracema do Tocantins",
    "Miranorte",
    "Monte do Carmo",
    "Monte Santo do Tocantins",
    "Muricilândia",
    "Natividade",
    "Nazaré",
    "Nova Olinda",
    "Nova Rosalândia",
    "Novo Acordo",
    "Novo Alegre",
    "Novo Jardim",
    "Oliveira de Fátima",
    "Palmas",
    "Palmeirante",
    "Palmeiras do Tocantins",
    "Palmeirópolis",
    "Paraíso do Tocantins",
    "Paranã",
    "Pau-d'Arco",
    "Pedro Afonso",
    "Peixe",
    "Pequizeiro",
    "Pindorama do Tocantins",
    "Piraquê",
    "Pium",
    "Ponte Alta do Bom Jesus",
    "Ponte Alta do Tocantins",
    "Porto Alegre do Tocantins",
    "Porto Nacional",
    "Praia Norte",
    "Presidente Kennedy",
    "Pugmil",
    "Recursolândia",
    "Riachinho",
    "Rio da Conceição",
    "Rio dos Bois",
    "Rio Sono",
    "Sampaio",
    "Sandolândia",
    "Santa Fé do Araguaia",
    "Santa Maria do Tocantins",
    "Santa Rita do Tocantins",
    "Santa Rosa do Tocantins",
    "Santa Tereza do Tocantins",
    "Santa Terezinha do Tocantins",
    "São Bento do Tocantins",
    "São Félix do Tocantins",
    "São Miguel do Tocantins",
    "São Salvador do Tocantins",
    "São Sebastião do Tocantins",
    "São Valério",
    "Silvanópolis",
    "Sítio Novo do Tocantins",
    "Sucupira",
    "Tabocão",
    "Taguatinga",
    "Taipas do Tocantins",
    "Talismã",
    "Tocantínia",
    "Tocantinópolis",
    "Tupirama",
    "Tupiratins",
    "Wanderlândia",
    "Xambioá",
  ],
};

export const UFStateMap = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

export const KINSHIP_INVERSE_MAP = {
  PARENT: KinShipEnum.CHILD,
  CHILD: KinShipEnum.PARENT,
  SPOUSE: KinShipEnum.SPOUSE,
  SIBLING: KinShipEnum.SIBLING,
};

export function formatPhoneNumber(phone: string): string {
  const digitsOnly = phone.replace(/-/g, "");
  return "+" + digitsOnly;
}
